/* eslint-disable quotes */
/* eslint-disable @typescript-eslint/indent */
/* eslint-disable @typescript-eslint/camelcase */
export const enTranslation = {
  translation: {
    DateRangeInfo: "Showing Data From",
    province: "province",
    district: "district",
    municipality: "municipality",
    ward: "ward",
    "Incident-wise details": "Incident-wise details",
    "Hazard-wise summary": "Hazard-wise summary",
    "Temporal summary": "Temporal summary",
    "Location-wise summary": "Location-wise summary",
    "Injured people": "Injured people",
    "Missing people": "Missing people",
    Admin: "Admin",
    "Feedback & Support": "Feedback & Support",
    "No Deaths Reported": "No Deaths Reported",
    incident: "Incidents",
    "Add New Hazard": "Add New Hazard",
    "Daily Disaster Bulletin": "Daily Disaster Bulletin",
    "COVID-19 Bulletin": "COVID-19 Bulletin",
    "Picture of Daily Rainfall Map": "Picture of Daily Rainfall Map",
    "Drag drop temperature files here, or click to select files":
      "Drag drop temperature files here, or click to select files",
    "Baisakh 1 to": "Baisakh 1 to",
    Hazard: "Hazard",
    Total: "Total",
    "No. of Incidents": "No. of Incidents",
    "Incident Details": "Incident Details",
    "Families Affected": "Families Affected",
    "S.N": "S.N",
    Response: "Response",
    "Provincewise stats till date": "Provincewise stats till date",
    "Incident Summary": "Incident Summary",
    "Disaster details of the last 24 hours":
      "Disaster details of the last 24 hours",
    "Provincewise Death, Missing and Injured Counts":
      "Provincewise Death, Missing and Injured Counts",
    "Genderwise Deaths": "Genderwise Deaths",
    "COVID-19 details of the last 24 hrs":
      "COVID-19 details of the last 24 hrs",
    "Stats till date": "Stats till date",
    "Vaccine Stats": "Vaccine Stats",
    "Daily Max Temperature": "Daily Max Temperature",
    "Daily Min Temperature": "Daily Min Temperature",
    "Daily Rain Summary": "Daily Rain Summary",
    "Daily Rainfall Map Description": "Daily Rainfall Map Caption",
    "Daily Max Temperature Map Description":
      "Daily Max Temperature Map Caption",
    "Daily Min Temperature Map Description":
      "Daily Min Temperature Map Caption",
    Annex: "Annex",
    "Complete details of the incidents": "Complete details of the incidents",
    "For additional info regarding this Bulletin:":
      "For additional info regarding this Bulletin:",
    "National Disaster Risk Reduction and Management Authority":
      "National Disaster Risk Reduction and Management Authority",
    "GPO Box Number": "GPO Box Number",
    Phone: "Phone",
    Email: "Email",
    "Daily Temperature and Rain Summary": "Daily Temperature and Rain Summary",
    Male: "Male",
    Female: "Female",
    "Percentage of 1st Dosage": "Percentage of 1st Dosage:",
    totalAffected: "Total Affected",
    totalActive: "Total Active",
    totalDeaths: "Total Deaths",
    "Total Affected": "Total Affected",
    "Total Active": "Total Active",
    "Total Deaths": "Total Deaths",
    "Total Recovered": "Total Recovered",
    "COVID-19 Stats till date": "COVID-19 Stats till date",
    "COVID-19 Stats for last 24 hours": "COVID-19 Stats for last 24 hours",
    "Genderwise Breakdown of Deaths": "Genderwise Breakdown of Deaths",
    "Hazardwise Breakdown of Incidents and Deaths":
      "Hazardwise Breakdown of Incidents and Death",
    "Third Dosage Count": "Third Dosage Count",
    "Death Count": "Death Count",
    "Hazard Legend": "Hazard Legend",
    death: "Death",
    missing: "Missing",
    injured: "Injured",
    "Province-wise death, missing and injured": "COVID19 stats province wise",
    "Hazard-wise breakdown of incidents (last 24 hours)":
      "Hazard-wise breakdown of incidents (last 24 hours) in map",
    "Disaster Hilights": "Disaster Highlights",
    "Nepal Government": "Nepal Government",
    "Ministry of Home Affairs": "Ministry of Home Affairs",
    ndrrma: "National Disaster Risk Reduction and Management Authority",
    "Daily Bipad Bulletin": "Daily Bipad Bulletin",
    "Disaster Incidents in last 24 hours": "Disaster summary of last 24 hours",
    Orientation: "Orientation",
    "Max value 5000 & Min value 500": "Max value 5000 & Min value 500",
    "File format": "File format",
    Resolution: "Resolution",
    "Resolution Type": "Resolution Type",
    "Page Type": "Page Type",
    Custom: "Custom",
    "Select Page Type": "Select Page Type",
    "Published by": "Published by",
    "Published on": "Published on",
    "BELOW WARNING LEVEL": "BELOW WARNING LEVEL",
    "ABOVE WARNING LEVEL": "ABOVE WARNING LEVEL",
    "ABOVE DANGER LEVEL": "ABOVE DANGER LEVEL",
    nepal_police: "nepal_police",
    "Nepal Police": "Nepal Police",
    "Name and contact number of technical staff":
      "Name and contact number of technical staff",
    Scale: "Scale",
    "Total capacity of the open space.": "Total capacity of the open space.",
    "Number of total employee trained in disaster management":
      "Number of total employee trained in disaster management",
    "Event On": "Event On",
    "Air Quality Index": "Air Quality Index",
    "Social Security": "Social Security",
    "Number of households": "Number of households",
    Occupation: "Occupation",
    Occupancy: "Occupancy",
    "Entry Date": "Entry Date",
    "Expiry Date": "Expiry Date",
    "Drinking Water": "Drinking Water",
    "Number of buildings": "Number of buildings",
    "Agriculture and Livestock": "Agriculture and Livestock",
    Agriculture: "Agriculture",
    "Agriculture Practice": "Agriculture Practice",
    "Agricultural Products": "Agricultural Products",
    "Major Agricultural products": "Major Agricultural products",
    "Physical Structure of House": "Physical Structure of House",
    "Majority of building type": "Majority of building type",
    "Building by Type of Superstructure": "Building by Type of Superstructure",
    "Majority of building": "Majority of building",
    "Buildings by Type of Foundation": "Buildings by Type of Foundation",

    Migration: "Migration",
    "Education Attainment": "Education Attainment",
    "Household ID": "Household ID",
    "Total Number of family members": "Total Number of family members",
    Ethinicity: "Ethinicity",
    Religion: "Religion",
    "Sensative Population": "Sensative Population",
    "Access to communication": "Access to Communication",
    "Access to Early Warning Information":
      "Access to Early Warning Information",
    "Access to Safe Shelter": "Access to Safe Shelter",
    "DRR training received": "DRR Training Received",
    "Above 60 years old": "Above 60 years old",
    "Pregnant Women": "Pregnant Women",
    "People With Disability": "People With Disability",
    "Children Below 5 Years old": "Children Below 5 Years old",
    "Building Structure": "Building Structure",
    "Age of Building": "Age of Building",
    "Annual Income": "Annual Income",
    "Supporting Occupation": "Supporting Occupation",
    "Major Occupation": "Major Occupation",
    "Economic Aspects": "Economic Aspects",
    "Building Foundation": "Building Foundation",
    "Roof Type": "Roof Type",
    "Number of Stories": "Number of Stories",

    Language: "Language",
    "GENERATE REPORT": "GENERATE REPORT",
    Rate: "Rate",
    "Select Date": "Select Date",
    About: "About",
    "Report Type": "Report Type",
    "Add Stock In": "Add Stock In",
    "Edit Stock In": "Edit Stock In",
    "Add Unit": "Add Unit",
    "Edit Unit": "Edit Unit",
    "Add Stock Out": "Add Stock Out",
    "Edit Stock Out": "Edit Stock Out",
    "Add Organization": "Add Organization",
    "Edit Organization": "Edit Organization",
    "NepDat Profile": "NepDat Profile",
    "Edit Document": "Edit Document",
    "Edit Item": "Edit Item",
    "Add Item": "Add Item",
    "Add Document": "Add Document",
    "Add document": "Add document",
    "Published Date": "Published Date",
    "Published By": "Published By",
    "No Description Available": "No Description Available",

    "Duration in Days": "Duration in Days",
    "Contact Training": "Contact Training",
    "Add Training": "Add Training",
    "Is DRR Focal Person": "Is DRR Focal Person",
    "Work Number": "Work Number",
    "Mobile Number": "Mobile Number",
    Committee: "Committee",
    "Community Address": "Community Address",

    "Edit Contact": "Edit Contact",
    "SEARCH BY POSITION": "SEARCH BY POSITION",
    "Add Contact": "Add Contact",
    Committe: "Committe",
    Action: "Action",
    Position: "Position",
    "No Training Attained": "No Training Attained",
    "Contact Personals": "Contact Personals",
    Budget: "Budget",
    "SEARCH BY TITLE": "SEARCH BY TITLE",
    "Table View": "Table View",
    "List View": "List View",
    "S/N": "S/N",
    Organization: "Organization",
    Project: "Project",
    "Budget(USD)": "Budget(USD)",

    "No Data Available": "No Data Available",
    Value: "Value",
    Percentage: "Percentage",
    Years: "Years",
    "Select Data Format": "Select Data Format",
    "Download Csv": "Download Csv",
    "Literacy Rate": "Literacy Rate",
    "Population By Age Group": "Population By Age Group",
    "Household Statistics": "Household Statistics",
    "Literacy Rate (%)": "Literacy Rate (%)",
    "Gender Breakdown": "Gender Breakdown",
    "Download Chart": "Download Chart",
    "Demography (Census 2011)": "Demography (Census 2011)",
    Demography: "Demography",
    Visualization: "Visualization",
    Demographics: "Demographics",
    "NEP-DAT Profile": "NEP-DAT Profile",
    Flow: "Flow",
    "Water Level": "Water Level",
    "Hourly Water Level": "Hourly Water Level",
    "Danger Level": "Danger Level",

    "Measured On": "Measured On",
    "Latest Rainfall": "Latest Rainfall",
    "Average Weekly Rainfall": "Average Weekly Rainfall",
    "Average Daily Rainfall": "Average Daily Rainfall",

    "Edit data": "Edit data",
    "View Details": "View Details",
    Inventories: "Inventories",
    "Inventory Details": "Inventory Details",
    "Capacity and Resources": "Capacity and Resources",
    "loading legend...": "loading legend...",
    Opacity: "Opacity",
    Year: "Year",
    temperature: "temperature",
    precipitation: "precipitation",
    Measurement: "Measurement",
    "Time period": "Time period",
    Scenario: "Scenario",
    "Precipitation data": "Precipitation data",
    "Temperature data": "Temperature data",
    "Show National Data": "Show National Data",
    "Links from Climate Scenarios from Nepal (NAP)":
      "Links from Climate Scenarios from Nepal (NAP)",

    "Climate change": "Climate change",
    Layers: "Layers",
    "Show visualizations": "Show visualizations",
    DATASET: "DATASET",
    VISUALIZATION: "VISUALIZATION",
    "Layer details": "Layer details",
    "Toggle opacity input visibility": "Toggle opacity input visibility",
    "Toggle legend visiblity": "Toggle legend visiblity",
    "Active layers": "Active layers",
    Preprimary: "Preprimary",
    Hospital: "Hospital",
    "Env. Pollution": "Env. Pollution",
    "Incident Feedbacks": "Incident Feedbacks",
    "Not provided": "Not provided",
    "Access Points": "Access Points",
    "Basic Health Care Center": "Basic Health Care Center",
    "Community Health Unit": "Community Health Unit",
    "Ayurveda Hospital": "Ayurveda Hospital",
    "Poly Clinic": "Poly Clinic",
    "General Hospital": "General Hospital",
    Clinic: "Clinic",
    "Urban Health Center": "Urban Health Center",
    Cooperative: "Cooperative",
    "Micro Credit Development": "Micro Credit Development",
    "Basic Education": "Basic Education",
    "Pre Primary": "Pre Primary",
    College: "College",
    Government: "Government",

    mm: "mm",
    Confidence: "Confidence",
    "Home Page": "Home Page",
    "Download Map": "Download Map",
    "Download with default settings": "Download with default settings",
    "Download with custom settings": "Download with custom settings",
    Streamflow: "Streamflow",
    Pollution: "Pollution",
    "No legends to display": "No legends to display",
    "Below Warning Level": "Below Warning Level",
    "Warning Level": "Warning Level",
    "Above Warning Level": "Above Warning Level",
    "Above Danger Level": "Above Danger Level",

    "Below Warning Level and Steady": "Below Warning Level and Steady",
    "Below Warning Level and Rising": "Below Warning Level and Rising",
    "Below Warning Level and Falling": "Below Warning Level and Falling",
    "Above Warning Level and Steady": "Above Warning Level and Steady",
    "Above Warning Level and Rising": "Above Warning Level and Rising",
    "Above Warning Level and Falling": "Above Warning Level and Falling",
    "Above Danger Level and Steady": "Above Danger Level and Steady",
    "Above Danger Level and Rising": "Above Danger Level and Rising",
    "Above Danger Level and Falling": "Above Danger Level and Falling",

    "Citizen Reports": "Citizen Reports",
    "Economic Loss": "Economic Loss",
    "Owner Name": "Owner Name",
    "Add Livestock Loss": "Add Livestock Loss",
    "Add Family Loss": "Add Family Loss",
    "Add / edit incident": "Add / edit incident",
    Age: "Age",
    Gender: "Gender",
    "Below Poverty": "Below Poverty",
    Count: "Count",
    Nationality: "Nationality",
    StockIn: "Stock In",
    StockOut: "Stock Out",
    "Add People Loss": "Add People Loss",
    "Are you sure you want to delete this item?":
      "Are you sure you want to delete this item?",
    Cause: "Cause",
    "Reported on": "Reported on",
    Approved: "Approved",
    "Need Followup": "Need Followup",
    "Verification Message": "Verification Message",

    "Stockpile Items": "Stockpile Items",
    Search: "Search",
    Item: "Item",
    Items: "Items",
    Categories: "Categories",
    Clusters: "Clusters",
    Quantity: "Quantity",
    Operator: "Operator",
    Unit: "Unit",
    "Search Resources": "Search Resources",
    "Health Post": "Health Post",
    "Primary Health Care Center": "Primary Health Care Center",
    "Development Bank": "Development Bank",
    Commercial: "Commercial",
    "High School": "High School",

    "Get direction": "Get direction",
    Resources: "Resources",
    Resource: "Resource",
    TransferToResource: 'Transfer To Resource',
    "People Dead": "People Dead",
    "Livestock Destroyed": "Livestock Destroyed",
    "Infrastructures Destroyed": "Infrastructures Destroyed",
    "Estimated Loss (NRs.)": "Estimated Loss (NRs.)",
    Yes: "Yes",
    No: "No",
    Loss: "Loss",
    "Are you sure you want to delete this incident?":
      "Are you sure you want to delete this incident?",
    "Reported On": "Reported On",
    Wards: "Wards",
    "Leave Feedback": "Leave Feedback",
    "Mobile number": "Mobile number",
    Comment: "Comment",
    "There are no incidents at the moment.":
      "There are no incidents at the moment.",
    "Metropolitan City": "Metropolitan City",
    "Submetropolitan City": "Submetropolitan City",
    "Rural Municipality": "Rural Municipality",
    "Add / edit alert": "Add / edit alert",
    "Started on": "Started on",
    "Expires on": "Expires on",
    Public: "Public",
    "Are you sure you want to close the form?":
      "Are you sure you want to close the form?",
    Confirm: "Confirm",
    Cancel: "Cancel",
    Ok: "Ok",
    "Are you sure to delete the Alert?": "Are you sure to delete the Alert?",

    "Shapefile needs to be uploaded first..":
      "Shapefile needs to be uploaded first..",
    "Upload cover image:": "Upload cover image:",
    Workspace: "Workspace",
    "Upload Document": "Upload Document",
    "Layer Name": "Layer Name",
    "Geoserver URL": "Geoserver URL",
    "Add shape file(.zip extension)": "Add shape file(.zip extension)",

    "Save and Continue": "Save and Continue",
    "Operated By": "Operated By",
    "Is the facility single story or multi story?":
      "Is the facility single story or multi story?",
    "Number of people that can be accommodated":
      "Number of people that can be accommodated",
    "Use of evacuation center, please specify":
      "Use of evacuation center, please specify",
    "Is drinking water available?": "Is drinking water available?",
    "Is toilet available?": "Is toilet available?",
    "How many toilets are available?": "How many toilets are available?",
    "How Many Toilets Are Available?": "How Many Toilets Are Available?",

    "Does the facility have hand washing facility?":
      "Does the facility have hand washing facility?",
    "How many hand washing facility is available?":
      "How many hand washing facility is available?",
    "Is food preparation facility available?":
      "Is food preparation facility available?",
    "How many food preparation facility is available?":
      "How many food preparation facility is available?",
    "Is sleeping facility available such as bed/cot/mat?":
      "Is sleeping facility available such as bed/cot/mat?",
    "How many sleeping facility is available?":
      "How many sleeping facility is available?",
    "Please specify Disable Friendly Infrastructures":
      "Please specify Disable Friendly Infrastructures",

    "Name of Focal Person": "Name of Focal Person",
    "Contact Information of Focal Person":
      "Contact Information of Focal Person",
    "Number of trained employee": "Number of trained employee",
    "Is safety equipment available?": "Is safety equipment available?",
    "Are there multiple municipalities that share the services from the firefighting apparatus?":
      "Are there multiple municipalities that share the services from the firefighting apparatus?",
    "Capacity (Litre)": "Capacity (Litre)",
    "Vehicle Number": "Vehicle Number",
    "Driver's Name": "Driver's Name",
    "Driver's Contact Number": "Driver's Contact Number",
    "Driver’s Alternative Number": "Driver’s Alternative Number",
    "Condition of Fire fighting apparatus":
      "Condition of Fire fighting apparatus",

    "Select either you are entering the details of vehicle center such as bus parks and stops or vehicle committee.":
      "Select either you are entering the details of vehicle center such as bus parks and stops or vehicle committee.",
    "Number of transportation facilities":
      "Number of transportation facilities",
    "Are disable friendly vehicle available?":
      "Are disable friendly vehicle available?",
    "Is the building designed following building code?":
      "Is the building designed following building code?",
    "Disable Friendly Vehicle types and count available?":
      "Disable Friendly Vehicle types and count available?",

    "Select the condition of boats": "Select the condition of boats",

    "Area of airport(Sq Km)": "Area of airport(Sq Km)",
    "Does the facility have humanitarian staging area?":
      "Does the facility have humanitarian staging area?",
    "Please specify,Disable friendly infrastructures":
      "Please specify,Disable friendly infrastructures",

    "Placement of Tank": "Placement of Tank",
    "Source of Water": "Source of Water",
    "Is electricity needed to pump water?":
      "Is electricity needed to pump water?",
    "When system was build?": "When system was build?",
    "Does the facility have technical staff?":
      "Does the facility have technical staff?",
    "Is the water supply infrastructure operational?":
      "Is the water supply infrastructure operational?",

    Area: "Area",
    "Is it Permanent?": "Is it Permanent?",
    "If the facility is public toilet, number of toilet available":
      "If the facility is public toilet, number of toilet available",
    "If the facility is public toilet, number of male toilet available":
      "If the facility is public toilet, number of male toilet available",
    "If the facility is public toilet, number of female toilet available":
      "If the facility is public toilet, number of female toilet available",
    "If the facility is public toilet, number of common toilet available":
      "If the facility is public toilet, number of common toilet available",
    "If the facility is public toilet, number of tabs available":
      "If the facility is public toilet, number of tabs available",

    "Status?": "Status?",
    "Capacity (In Megawatt)": "Capacity (In Megawatt)",
    Promoter: "Promoter",

    "From When was the bridge operational?":
      "From When was the bridge operational?",
    "Is the bridge motorable?": "Is the bridge motorable?",
    "Length (in meter)": "Length (in meter)",
    "Width (in meter)": "Width (in meter)",
    "Condition of Bridge?": "Condition of Bridge?",
    "How many lane does the bridge have?":
      "How many lane does the bridge have?",

    "Operating Date": "Operating Date",
    Ownership: "Ownership",
    "Is the helipad build following the standard operational guidelines, 2075 of Civil Aviation Authority of Nepal?":
      "Is the helipad build following the standard operational guidelines, 2075 of Civil Aviation Authority of Nepal?",
    "Area of Helipad(sq m)": "Area of Helipad(sq m)",
    Altitude: "Altitude",
    "HELIPAD DETAILS": "HELIPAD DETAILS",
    "Surface Level": "Surface Level",
    "Surface Type": "Surface Type",
    "Has Road Access?": "Has Road Access?",
    "Has Storage Facility Available?": "Has Storage Facility Available?",
    "Has Internet Facility Available?": "Has Internet Facility Available?",
    "Has Wind Direction Indicator Available?":
      "Has Wind Direction Indicator Available?",
    "Has Heli Marker Available?": "Has Heli Marker Available?",
    "Has Night lighting Available?": "Has Night lighting Available?",
    "Condition Of Helipad?": "Condition Of Helipad?",

    "Name of the tower (Radio tower)": "Name of the tower (Radio tower)",
    "Average coverage radius in km": "Average coverage radius in km",
    "Frequency in megahertz": "Frequency in megahertz",
    "Does the facility have internet service available?":
      "Does the facility have internet service available?",

    "Does the facility have electricity facility?":
      "Does the facility have electricity facility?",
    "If other facilities are available, please specify.":
      "If other facilities are available, please specify.",
    "Number of cots available": "Number of cots available",
    "Number of mats available": "Number of mats available",
    "Has sleeping facility available?": "Has sleeping facility available?",
    "Does the facility have WASH facility?":
      "Does the facility have WASH facility?",
    "Is toilet available? ": "Is toilet available? ",
    "Is drinking water available? ": "Is drinking water available? ",

    "Number of rooms": "Number of rooms",
    "Number of beds": "Number of beds",
    "Number of Beds": "Number of Beds",
    "Number of Service Users": "Number of Service Users",
    "Facility Type": "Facility Type",
    "Does the facility have disaster management unit available?":
      "Does the facility have disaster management unit available?",
    "Has employee trained in disaster management?":
      "Has employee trained in disaster management?",
    "Does the institution has helipad?": "Does the institution has helipad?",
    Bank: "Bank",
    "Money Exchange": "Money Exchange",
    ATM: "ATM",
    Other: "Other",
    other: "other",
    "Other Services": "Other Services",
    "Number of Male Employee": "Number of Male Employee",
    "Number of Female Employee": "Number of Female Employee",
    "Number of Other Employee": "Number of Other Employee",
    "Total Number of Employee": "Total Number of Employee",

    "Please specify HF Code": "Please specify HF Code",
    Code: "Code",
    Authority: "Authority",
    "Authority Level": "Authority Level",
    OwnerShip: "OwnerShip",
    "Service Type": "Service Type",
    "Operational Status": "Operational Status",
    "Number of available bed ": "Number of available bed ",
    "Hospital Bed": "Hospital Bed",
    "ICU Bed": "ICU Bed",
    "Ventilator Bed": "Ventilator Bed",
    "SERVICES AVAILABLE": "SERVICES AVAILABLE",
    "Child Immunization": "Child Immunization",
    "TD Vaccination": "TD Vaccination",
    "Vaccination facility": "Vaccination facility",
    "Integrated Management of Neonatal and Childhood Illness (IMNCI)":
      "Integrated Management of Neonatal and Childhood Illness (IMNCI)",
    "Growth Monitoring": "Growth Monitoring",
    "Safe Motherhood": "Safe Motherhood",
    "Antenatal Care": "Antenatal Care",
    "Postnatal Care": "Postnatal Care",
    "Birthing/Delivery Services": "Birthing/Delivery Services",
    "Basic Emergency Obstetric Care (BEOC)":
      "Basic Emergency Obstetric Care (BEOC)",
    "Comprehensive Emergency Obstetric Care (CEOC)":
      "Comprehensive Emergency Obstetric Care (CEOC)",
    "Comprehensive Abortion Care": "Comprehensive Abortion Care",
    "Post Abortion Care": "Post Abortion Care",
    "Family planning": "Family planning",
    "Condom/Pills/Depo-Provera": "Condom/Pills/Depo-Provera",
    IUCD: "IUCD",
    Implant: "Implant",
    Vasectomy: "Vasectomy",
    Minilap: "Minilap",
    OPD: "OPD",
    General: "General",
    Pediatric: "Pediatric",
    "Obs. and Gynae": "Obs. and Gynae",
    Surgery: "Surgery",
    Gastrointestinal: "Gastrointestinal",
    Cardiac: "Cardiac",
    Mental: "Mental",
    Respiratory: "Respiratory",
    Nephrology: "Nephrology",
    ENT: "ENT",
    Dermatology: "Dermatology",
    tole: "Tole",
    Endocrinology: "Endocrinology",
    Oncology: "Oncology",
    Neurology: "Neurology",
    Ophthalmology: "Ophthalmology",
    "Treatment of Tuberculosis": "Treatment of Tuberculosis",
    "Treatment of Multi-drug resistance (MDR) tuberculosis":
      "Treatment of Multi-drug resistance (MDR) tuberculosis",
    "Treatment of Leprosy": "Treatment of Leprosy",
    "Treatment of Malaria": "Treatment of Malaria",
    "Treatment of Kala-azar": "Treatment of Kala-azar",
    "Treatment of Japanese Encephalitis": "Treatment of Japanese Encephalitis",
    "Laboratory Service": "Laboratory Service",
    "HIV test": "HIV test",
    "Malaria test": "Malaria test",
    "Tuberculosis test": "Tuberculosis test",
    "Kala-azar test": "Kala-azar test",
    "Urine RE": "Urine RE",
    "Stool RE": "Stool RE",
    "General Blood CBC": "General Blood CBC",
    Culture: "Culture",
    Hormones: "Hormones",
    "Leprosy Smear test": "Leprosy Smear test",
    "COVID PCR": "COVID PCR",
    "COVID Antigen": "COVID Antigen",
    "Volunteer Counseling Test (VCT) for HIV/AIDS":
      "Volunteer Counseling Test (VCT) for HIV/AIDS",
    "Prevention of mother-to-child transmission (PMTCT)":
      "Prevention of mother-to-child transmission (PMTCT)",
    "Anti-retro Viral Treatment": "Anti-retro Viral Treatment",
    Dental: "Dental",
    "In Patient": "In Patient",
    Radiology: "Radiology",
    "X-ray": "X-ray",
    "X-ray with contrast": "X-ray with contrast",
    Ultrasound: "Ultrasound",
    Echocardiogram: "Echocardiogram",
    ECG: "ECG",
    Trademill: "Trademill",
    "CT Scan": "CT Scan",
    MRI: "MRI",
    Endoscopy: "Endoscopy",
    Colonoscopy: "Colonoscopy",
    "Surgical Service": "Surgical Service",
    "Caesarian Section": "Caesarian Section",

    "Gastro Intestinal": "Gastro Intestinal",
    "Trauma Surgery": "Trauma Surgery",
    "Cardiac Surgery": "Cardiac Surgery",
    "Neuro Surgery": "Neuro Surgery",
    "Plastic Surgery": "Plastic Surgery",
    "Specialized Service": "Specialized Service",
    ICU: "ICU",
    CCU: "CCU",
    NICU: "NICU",
    MICU: "MICU",
    SNCU: "SNCU",
    PICU: "PICU",
    "Cardiac Catheterization": "Cardiac Catheterization",
    Physiotherapy: "Physiotherapy",
    "Ambulance services": "Ambulance services",
    "Extended Health Service": "Extended Health Service",
    "Geriatric Ward": "Geriatric Ward",
    Pharmacy: "Pharmacy",
    OCMC: "OCMC",
    "Health Insurance": "Health Insurance",
    SSU: "SSU",
    "Ayurveda Service": "Ayurveda Service",
    "COVID Clinic Service": "COVID Clinic Service",
    "Emergency services": "Emergency services",
    "Operating theatre": "Operating theatre",
    "Blood donation": "Blood donation",
    "LISTED FOR FREE TREATMENT BIPANNA": "LISTED FOR FREE TREATMENT BIPANNA",
    "Kidney Dialysis": "Kidney Dialysis",
    "Kidney Transplant": "Kidney Transplant",
    "Medication After Kidney Transplant": "Medication After Kidney Transplant",
    "Head Injury": "Head Injury",
    "Spinal Injury": "Spinal Injury",
    Alzheimer: "Alzheimer",
    Cancer: "Cancer",
    Heart: "Heart",
    New: "New",
    Parkinson: "Parkinson",
    "NUMBER OF EMPLOYEES": "NUMBER OF EMPLOYEES",
    "Number Of Male Employee": "Number Of Male Employee",
    "Number Of Female Employee": "Number Of Female Employee",
    "Number Of Other Employee": "Number Of Other Employee",
    "Total Number Of Employee": "Total Number Of Employee",
    "Number of Differently-abled Male Employees":
      "Number of Differently-abled Male Employees",
    "Number of Differently-abled Female Employees":
      "Number of Differently-abled Female Employees",
    "Number of Differently-abled Other Employees":
      "Number of Differently-abled Other Employees",
    specialization: "specialization",
    "Last Renewal Date": "Last Renewal Date",
    "Date of Validity": "Date of Validity",
    "DISASTER MANAGEMENT": "DISASTER MANAGEMENT",
    "Is the facility designed following building codes?":
      "Is the facility designed following building codes?",
    "Does the facility have disabled friendly infrastructure?":
      "Does the facility have disabled friendly infrastructure?",
    "Disable Friendly Infrastructures": "Disable Friendly Infrastructures",

    "Does the institution have helipad facility?":
      "Does the institution have helipad facility?",
    "Does the institution have evacuation route?":
      "Does the institution have evacuation route?",
    "Does the institution have disaster focal point person?":
      "Does the institution have disaster focal point person?",
    "Disaster Focal Person Name": "Disaster Focal Person Name",

    "Focal Person Contact Number": "Focal Person Contact Number",
    "Does the institution has open space?":
      "Does the institution has open space?",
    "Does the institution has medical storage space?":
      "Does the institution has medical storage space?",
    "Does the institution have electricity backup?":
      "Does the institution have electricity backup?",
    "OPENING HOUR": "OPENING HOUR",
    "Start Time": "Start Time",
    "End Time": "End Time",
    "Remarks on Opening Hours": "Remarks on Opening Hours",
    CONTACT: "CONTACT",
    "Phone Number": "Phone Number",
    "Email Address": "Email Address",
    Website: "Website",
    "Local Address": "Local Address",
    remarks: "Remarks",
    attachment: "Attachment",
    "Operator Type": "Operator Type",
    "Please specify operator type": "Please specify operator type",
    "Number of Classrooms": "Number of Classrooms",
    "Area Of School (Sq.Km)": "Area Of School (Sq.Km)",

    "Number of Female Employees": "Number of Female Employees",
    "Number of Male Employees": "Number of Male Employees",
    "Number of Other Employees": "Number of Other Employees",
    "Total Number of Employees": "Total Number of Employees",
    "NUMBER OF STUDENTS": "NUMBER OF STUDENTS",
    "Number of Male Students": "Number of Male Students",
    "Number of Female Students": "Number of Female Students",
    "Number of Other Students": "Number of Other Students",
    "Total Number of Students": "Total Number of Students",
    "Number of Differently-abled Male Students":
      "Number of Differently-abled Male Students",
    "Number of Differently-abled Female Students":
      "Number of Differently-abled Female Students",
    "Number of Differently-abled Other Students":
      "Number of Differently-abled Other Students",
    "STUDENT AGE GROUP": "STUDENT AGE GROUP",
    "Less than 10 years": "Less than 10 years",
    "Between 10-15 years": "Between 10-15 years",
    "Between 15-20 years": "Between 15-20 years",
    "Above 20 years": "Above 20 years",
    "Is the school designed following building codes?":
      "Is the school designed following building codes?",
    "Remarks on Building Code": "Remarks on Building Code",
    "Does the facility have open space?": "Does the facility have open space?",
    "Area of Open Space (Sq.Km) ": "Area of Open Space (Sq.Km)",
    "Does the facility have evacuation route?":
      "Does the facility have evacuation route?",
    "Does the school have disaster committee or/and other related clubs?":
      "Does the school have disaster committee or/and other related clubs?",
    "Disaster Management committee or related Clubs":
      "Disaster Management committee or related Clubs",
    "Has disaster related awareness and training programs been conducted within the school?":
      "Has disaster related awareness and training programs been conducted within the school?",
    "Name of Disaster related awareness and training program conducted within the school.":
      "Name of Disaster related awareness and training program conducted within the school.",
    "Does the school provide disaster related education to students?":
      "Does the school provide disaster related education to students?",
    "Disaster related education provided by school":
      "Disaster related education provided by school",
    "Does the school have health center and/or psycho-counseling?":
      "Does the school have health center and/or psycho-counseling?",
    "Remarks on opening hours": "Remarks on opening hours",
    "Transfer to Resource": "Transfer to Resource",
    "Add Resource": "Add Resource",
    Clear: "Clear",
    "Resource Type": "Resource Type",
    "INSTITUTION DETAILS": "INSTITUTION DETAILS",
    "GENERAL DETAILS": "GENERAL DETAILS",
    Name: "Name",
    "Submit Changes": "Submit Changes",

    "There are no alerts at the moment.": "There are no alerts at the moment.",
    "Hotel and Restaurant": "Hotel and Restaurant",
    "Search for an option": "Search for an option",
    Person: "Person",
    Beneficiary: "Beneficiary",
    "Beneficiary Other": "Beneficiary Other",
    Title: "Title",
    "Short Name": "Short Name",
    "Long Name": "Long Name",
    "Incident Verification Duration": "Incident Verification Duration",

    "Receiver Organization": "Receiver Organization",
    "Provider Organization": "Provider Organization",
    Amount: "Amount",
    Type: "Type",
    Event: "Event",
    "Fiscal Year": "Fiscal Year",
    Date: "Date",
    Save: "Save",

    Releases: "Releases",
    "New Release": "New Release",
    "Add Release": "Add Release",
    "Add Flow": "Add Flow",
    Flows: "Flows",
    "New Flow": "New Flow",
    "Close Modal": "Close Modal",
    Documents: "Documents",
    "New document": "New document",
    Category: "Category",
    "Nothing to show.": "Nothing to show.",
    "Date of publication": "Date of publication",
    "Are you sure you want to delete this document?":
      "Are you sure you want to delete this document?",

    "Contact personnels": "Contact personnels",
    "No. of Projects": "No. of Projects",
    "No. of projects": "No. of projects",
    "priority area": "priority area",
    "priority action": "priority action",
    activities: "activities",
    organization: "organization",

    "Download csv": "Download csv",
    "Note : Warning level for rainfall (mm): 60 mm in 1 hr, 80 mm in 3 hr, 100 mm in 6 hr, 120 mm in 12 hr, 140 mm in 24 hr. This indicates potential threat for landslides in steep slope and high flow in local areas.":
      "Note : Warning level for rainfall (mm): 60 mm in 1 hr, 80 mm in 3 hr, 100 mm in 6 hr, 120 mm in 12 hr, 140 mm in 24 hr. This indicates potential threat for landslides in steep slope and high flow in local areas.",

    "Rainfall Watch": "Rainfall Watch",
    "No Publications to display": "No Publications to display",
    "BIPAD: Building Information Platform Against Disaster":
      "BIPAD: Building Information Platform Against Disaster",
    "Disaster related data/information is one of the most crucial components for policy making, planning, and implementing DRRM activities.BIPAD is built at a time when disaster governance in Nepal is changing on account of federal restructuring of the country.However, disaster data/information is still scattered, insufficient and not fully harmonized.On this backdrop, BIPAD is developed by pooling all credible digital and spatial data that are available within different government bodies, non-governmental organizations, academic institutions and research organizations on a single platform.The platform has six modules in the portal that has the potential to:":
      "Disaster related data/information is one of the most crucial components for policy making, planning, and implementing DRRM activities.BIPAD is built at a time when disaster governance in Nepal is changing on account of federal restructuring of the country.However, disaster data/information is still scattered, insufficient and not fully harmonized.On this backdrop, BIPAD is developed by pooling all credible digital and spatial data that are available within different government bodies, non-governmental organizations, academic institutions and research organizations on a single platform.The platform has six modules in the portal that has the potential to:",
    "Enhance preparedness and early warning":
      "Enhance preparedness and early warning",
    "Strengthen disaster communication": "Strengthen disaster communication",
    "Strengthen emergency response": "Strengthen emergency response",
    "Enhance coordination post-incident": "Enhance coordination post-incident",
    "Evidence-based planning, decision making and policy making":
      "Evidence-based planning, decision making and policy making",
    "The focus of the system is on bottom up approach of data collection,targeting the Provincial and Municipal governments to engage in verifying and collecting data.BIPAD is targeted for Emergency Operation Centers at National, Provincial and Municipal tiers of the government, and Nepal Police, who is the first responder to disaster. Other users of this system are the line ministries at National and Provincial tiers working in disaster management division and departments, Nepal Army, Armed Police Force, non-governmental organizations, research institutions and the general public.":
      "The focus of the system is on bottom up approach of data collection,targeting the Provincial and Municipal governments to engage in verifying and collecting data.BIPAD is targeted for Emergency Operation Centers at National, Provincial and Municipal tiers of the government, and Nepal Police, who is the first responder to disaster. Other users of this system are the line ministries at National and Provincial tiers working in disaster management division and departments, Nepal Army, Armed Police Force, non-governmental organizations, research institutions and the general public.",
    "The features in BIPAD inform the users about the details of an incident for both natural and non-natural hazards for response and for historical analysis of loss and damage. The system integrates electronic version of the incident reporting form used in collecting incident information by Nepal Police.":
      "The features in BIPAD inform the users about the details of an incident for both natural and non-natural hazards for response and for historical analysis of loss and damage. The system integrates electronic version of the incident reporting form used in collecting incident information by Nepal Police.",
    "The alert feature has the potential to pre-inform to take early actions to mitigate   disasters. BIPAD targets to provide crucial information on the capacity and resources, such as on health institutions, financial institutions, schools, banks, stockpiles, road network, inventories, NGOs, government agencies, etc. in relation to the incidents. The system incorporates hazard maps and vulnerability indicators that can be used for risk sensitive land use planning and DRR inclusive development activities. The system is built to accommodate repository of DRRM documents, status of DRRM projects, and relief budget tracking. It has provisions to monitor the government’s as well as non-government organizations’ projects on the basis of seven targets of Sendai Framework (2015-2030) and Priorities and Sub-Priorities of Disaster Risk Reduction Strategic Action plan 2018.":
      "The alert feature has the potential to pre-inform to take early actions to mitigate   disasters. BIPAD targets to provide crucial information on the capacity and resources, such as on health institutions, financial institutions, schools, banks, stockpiles, road network, inventories, NGOs, government agencies, etc. in relation to the incidents. The system incorporates hazard maps and vulnerability indicators that can be used for risk sensitive land use planning and DRR inclusive development activities. The system is built to accommodate repository of DRRM documents, status of DRRM projects, and relief budget tracking. It has provisions to monitor the government’s as well as non-government organizations’ projects on the basis of seven targets of Sendai Framework (2015-2030) and Priorities and Sub-Priorities of Disaster Risk Reduction Strategic Action plan 2018.",
    "The above features of the system would be fully functional when credible data/information is integrated into the system coming from local level. The system is committed for the same.":
      "The above features of the system would be fully functional when credible data/information is integrated into the system coming from local level. The system is committed for the same.",

    "Please provide the following details":
      "Please provide the following details",
    "Download a sample letter": "Download a sample letter",
    "Welcome Back": "Welcome Back",
    "To login to BIPAD Portal, please use your credentials.":
      "To login to BIPAD Portal, please use your credentials.",
    "Sign in": "Sign in",
    "You are representing:": "You are representing:",
    "Please select at least one field": "Please select at least one field",
    Back: "Back",
    Next: "Next",
    "I Agree": "I Agree",
    "Thank you": "Thank you",
    Close: "Close",
    "For requesting the login credential.Following the submission, you will receive a confirmation email with a confirmation code.Our technical team will review your details and provide you a username and password.":
      "For requesting the login credential.Following the submission, you will receive a confirmation email with a confirmation code.Our technical team will review your details and provide you a username and password.",
    "The official email will be registered in the system and will be used as the primary email for any official correspondence.":
      "The official email will be registered in the system and will be used as the primary email for any official correspondence.",
    "Valid Official Email is required": "Valid Official Email is required",
    "Valid Phone no. is required": "Valid Phone no. is required",
    "Designation is required": "Designation is required",
    "Full Name is required": "Full Name is required",
    "Full Name": "Full Name",
    "Desingation (eg. IT Officer)": "Desingation (eg. IT Officer)",
    "+977": "+977",
    "Phone No.": "Phone No.",
    "Official Email": "Official Email",
    "Please attach the official letter": "Please attach the official letter",
    "Please choose a valid letter file(.jpg, .jpeg, .pdf, .doc, .docx, .png)":
      "Please choose a valid letter file(.jpg, .jpeg, .pdf, .doc, .docx, .png)",
    "BIPAD portal is a Government owned integrated and comprehensive Disaster Information Management System.It aims to bring together all credible digital and spatial data into a single platform to strengthen the preparedness, mitigation, and response activities of all related stakeholders working in this sector.This one stop platform has been developed with the concept of creating a national portal embedded with independent platforms for national, provincial, and municipal government with a bottom-up approach of disaster data partnership.":
      "BIPAD portal is a Government owned integrated and comprehensive Disaster Information Management System.It aims to bring together all credible digital and spatial data into a single platform to strengthen the preparedness, mitigation, and response activities of all related stakeholders working in this sector.This one stop platform has been developed with the concept of creating a national portal embedded with independent platforms for national, provincial, and municipal government with a bottom-up approach of disaster data partnership.",
    "Authorized government body from each province, district, and municipality will receive a single login credential.You can request for the username and password once.":
      "Authorized government body from each province, district, and municipality will receive a single login credential.You can request for the username and password once.",
    "I hereby confirm that I am a government employee requesting for the login credential for the first time":
      "I hereby confirm that I am a government employee requesting for the login credential for the first time",
    "Please agree to the terms and conditions before continuing":
      "Please agree to the terms and conditions before continuing",

    "Welcome to BIPAD Portal": "Welcome to BIPAD Portal",
    "An integrated and comprehensive DIMS platform to support disaster risk management through informed decision making.":
      "An integrated and comprehensive DIMS platform to support disaster risk management through informed decision making.",
    Username: "Username",
    Password: "Password",
    "Forgot Password": "Forgot Password",
    Login: "Login",
    "Other logins:": "Other logins:",
    MDSA: "MDSA",
    "Do not have an account?": "Do not have an account?",
    "Click to request BIPAD login credential":
      "Click to request BIPAD login credential",
    "PASSWORD REQUEST": "PASSWORD REQUEST",
    "Disaster count": "Disaster count",
    Relocated: "Relocated",
    Evacuated: "Evacuated",
    Dimension: "Dimension",
    "Livestock Loss": "Livestock Loss",
    Destroyed: "Destroyed",
    "Infrastructure Loss": "Infrastructure Loss",
    House: "House",
    Bridges: "Bridges",
    Bridge: "Bridge",
    Road: "Road",
    "Title Nepali": "Title Nepali",
    "Short Description": "Short Description",
    Electricity: "Electricity",
    "Please select a situation report": "Please select a situation report",
    "There are no incidents in this situation report":
      "There are no incidents in this situation report",
    "Disaster Summary": "Disaster Summary",
    "Family Loss": "Family Loss",
    "People Loss": "People Loss",
    "Casuality Statistics": "Casuality Statistics",
    Download: "Download",
    "Incident Situation Report": "Incident Situation Report",
    "Incident Statistics": "Incident Statistics",
    "BIPAD Portal": "BIPAD Portal",
    "Bipad Portal": "Bipad Portal",
    Region: "Region",
    "Loading data": "Loading data",
    "Loading Page": "Loading Page",
    "Loading Resources": "Loading Resources",
    Latitude: "Latitude",
    Longitude: "Longitude",
    Description: "Description",
    "Street Address": "Street Address",
    "Upload Image": "Upload Image",
    Image: "Image",
    "Incident on": "Incident on",
    "Some problem occurred.": "Some problem occurred.",
    Reload: "Reload",
    "Risk Info / Hazard": "Risk Info / Hazard",
    "Risk Info / Exposure": "Risk Info / Exposure",
    "Risk Info / Vulnerability": "Risk Info / Vulnerability",
    "Risk Info / Risk": "Risk Info / Risk",
    "Risk Info / Capacity and Resources": "Risk Info / Capacity and Resources",
    "Risk Info / Climate change": "Risk Info / Climate change",
    Population: "Population",
    Literacy: "Literacy",
    Household: "Household",
    "Age Group": "Age Group",
    "Demographics of Nepal": "Demographics of Nepal",
    "Loss by year": "Loss by year",
    Death: "Death",
    Injury: "Injury",
    Injured: "Injured",
    Affected: "Affected",
    Missing: "Missing",
    "Infrastructures destroyed": "Infrastructures destroyed",
    Summary: "Summary",
    Projects: "Projects",
    Contacts: "Contacts",
    Document: "Document",
    Indicators: "Indicators",
    "Available resources": "Available resources",
    Realtime: "Realtime",
    Education: "Education",
    Health: "Health",
    Finance: "Finance",
    Communication: "Communication",
    Governance: "Governance",
    Tourism: "Tourism",
    Industries: "Industries",
    "Religious sites": "Religious Sites",
    "Energy station": "Energy Station",
    Profile: "Profile",
    "Risk Info": "Risk Info",
    National: "National",
    Logout: "Logout",
    "About Us": "About Us",
    "Reported incidents": "Reported incidents",
    "Report an incident": "Report Incident",
    Relief: "Relief",
    "Situation Report": "Situation Report",
    "Data Archive": "Data Archive",
    "DRRM Report": "DRRM Report",
    "Viz Risk": "Viz Risk",
    "Rain watch": "Rain watch",
    "River watch": "River watch",
    "River Watch": "River Watch",
    to: "to",
    "Realtime Module": "Realtime Module",
    Alerts: "Alerts",
    Events: "Events",
    Visualizations: "Visualizations",
    "New alert": "New alert",
    "New event": "New event",
    "Flood at": "Flood at",
    Ma: "",
    "Earthquake at": "Earthquake at",
    Edit: "Edit",
    Delete: "Delete",
    Filters: "Filters",
    Submit: "Submit",
    Dashboard: "Dashboard",
    Incident: "Incident",
    "Damage & Loss": "Damage & Loss",
    "There are no major events at the moment.":
      "There are no major events at the moment.",
    "Number of Alerts": "Number of Alerts",
    "No Alerts in the Selected Time Period":
      "No Alerts in the Selected Time Period",
    "Hazard Occurence Statistics": "Hazard Occurence Statistics",
    hazardSummary: [
      {
        label: "Earthquake",
      },
      {
        label: "Env. Pollution",
      },
      {
        label: "Flood",
      },
      {
        label: "Heavy Rainfall",
      },
    ],
    "Data sources": "Data sources",
    "DRR Portal": "DRR Portal",
    Incidents: "Incidents",
    "People death count": "People death count",
    "Hazards Legend": "Hazards Legend",
    "New incident": "New incident",
    Feedbacks: "Feedbacks",
    "Feedback and support": "Feedback & Support",
    Source: "Source",
    Status: "Status",
    Verified: "Verified",
    "Not verified": "Not Verified",
    "Go to response": "Go to Response",
    "High Altitude": "High Altitude",
    Landslide: "Landslide",
    Flood: "Flood",
    "Boat Capsize": "Boat Capsize",
    Thunderbolt: "Thunderbolt",
    "Snake Bite": "Snake Bite",
    Fire: "Fire",
    Drowning: "Drowning",
    "Heavy Rainfall": "Heavy Rainfall",
    "Wind Storm": "Wind Storm",
    "Cold Wave": "Cold Wave",
    Earthquake: "Earthquake",
    "Helicopter Crash": "Helicopter Crash",
    "Leakage (toxic gas)": "Leakage (toxic gas)",
    "Response Accident": "Response Accident",
    Hailstorm: "Hailstorm",
    "Forest Fire": "Forest Fire",
    "Leakage (radiation)": "Leakage (radiation)",
    Epidemic: "Epidemic",
    "Leakage (chemical)": "Leakage (chemical)",
    "Volcanic eruption": "Volcanic eruption",
    "Bridge Collapse": "Bridge Collapse",
    Avalanche: "Avalanche",
    "Animal Incidents": "Animal Incidents",
    "Aircraft Accident": "Aircraft Accident",
    Inundation: "Inundation",
    "Animal flu": "Animal flu",
    "Water Accident": "Water Accident",
    "Gas explosion": "Gas explosion",
    "Food poisoning": "Food poisoning",
    Famine: "Famine",
    "Soil Erosion": "Soil Erosion",
    "Other (Natural)": "Other (Natural)",
    "Glacial lake": "Glacial lake",
    "Microorganism attack": "Microorganism attack",
    "Environmental pollution": "Environmental pollution",
    "Heat wave": "Heat wave",
    Storm: "Storm",
    "Mine disaster": "Mine disaster",
    "Road accident": "Road accident",
    "Industrial disaster": "Industrial disaster",
    "Add Cluster": "Add Cluster",
    "Edit Cluster": "Edit Cluster",
    "Add Category": "Add category",
    "Edit Category": "Edit Category",
    Drought: "Drought",
    Pandemics: "Pandemics",
    "Snow Storm": "Snow Storm",
    Deforestation: "Deforestation",
    Rainfall: "Rainfall",
    Province: "Province",
    District: "District",
    Municipality: "Municipality",
    Ward: "Ward",
    "All districts": "All districts",
    "All municipalities": "All municipalities",
    "All provinces": "All provinces",
    "All wards": "All wards",
    Location: "Location",
    "Reset filters": "Reset Filters",
    "Data range": "Data range",
    Others: "Others",
    Natural: "Natural",
    "Non-natural": "Non-natural",
    "Start Date": "Start Date",
    "End Date": "End Date",
    "owner gender": "Owner's Gender",
    "sensative population": "Sensative Population",
    "(NPT)": "(नेपाली समय)",
    "N/A": "N/A",
    Magnitude: "Magnitude",
    "Department of Mines and Geology": "Department of Mines and Geology",
    ML: "ML",
    "International Centre for Integrated Mountain Development":
      "International Centre for Integrated Mountain Development",
    "Land Cover": "Land Cover",
    Good: "Good",
    Moderate: "Moderate",
    "Unhealthy for Sensitive People": "Unhealthy for Sensitive People",
    Unhealthy: "Unhealthy",
    Hazardous: "Hazardous",
    "Ministry of Forests and Environment":
      "Ministry of Forests and Environment",
    Remark: "Remark",
    AQI: "AQI",
    Basin: "Basin",
    "Accumulated Rainfall": "Accumulated Rainfall",
    Hour: "Hour",
    "Department of Hydrology and Meteorology":
      "Department of Hydrology and Meteorology",
    "Station Name": "Station Name",
    "WATER LEVEL": "WATER LEVEL",
    "People death": "People death",
    "Estimated loss (NPR)": "Estimated loss (NPR)",
    "Infrastructure destroyed": "Infrastructure destroyed",
    "Livestock destroyed": "Livestock destroyed",
    "LEAVE FEEDBACK": "LEAVE FEEDBACK",
    "Number of Incidents": "Number of Incidents",
    "Hazard Severity (Fatality due to Hazard)":
      "Hazard Severity (Fatality due to Hazard)",
    DateMismatchWarning: "WARNING! Start date cannot be greater than End Date",
    "Compare Regions": "Compare Regions",
    "Show data in tabular format": "Show data in tabular format",
    "No. of incidents": "No. of incidents",
    "Estimated loss": "Estimated loss",
    in: "in",
    "First location": "First location",
    "Second location": "Second location",
    "Select an option": "Select an option",
    SelectMessage: "Please select locations to start the comparison",
    "Estimated Monetary Loss": "Estimated Monetary Loss",
    "Death toll by disaster": "Death toll by disaster",
    "Estimated economic loss by disaster":
      "Estimated economic loss by disaster",
    "Realtime layers": "Realtime layers",
    "Other layers": "Other layers",
    Rain: "Rain",
    River: "River",
    "Earthquake (ML)": "Earthquake (ML)",
    "Pollution (AQI Value)": "Pollution (AQI Value)",
    StreamFlow: "StreamFlow",
    IBF: "IBF",
    "Drought Watch": "Drought Watch",
    "Brand Registration Number": "Brand Registration Number",
    "Reference Number": "Reference Number",
    "Please select resource list to search":
      "Please select resource list to search",
    ID: "ID",
  },
};

export const npTranslation = {
  translation: {
    province: "प्रदेश",
    district: "जिल्‍ला",
    municipality: "नगरपालिका",
    ward: "वार्ड",
    "Incident-wise details": "घटना अनुसार विवरण",
    "Hazard-wise summary": "प्रकोप अनुसार विवरण",
    "Temporal summary": "समय अनुसार विवरण ",
    "Location-wise summary": "स्थान अनुसार विवरण",
    "Injured people": "घाइते संख्या",
    "Missing people": "हराएको संख्या",
    "Drought Watch": "खडेरी अवलोकन",
    Admin: "प्रशासक",
    "Feedback & Support": "प्रतिक्रिया र समर्थन",
    "No Deaths Reported": "कुनै मृत्यु रिपोर्ट गरिएको छैन",
    incident: "घटना",
    "Add New Hazard": "नयाँ प्रकोप थप्नुहोस्",
    "Daily Disaster Bulletin": "दैनिक विपद् बुलेटिन",
    "COVID-19 Bulletin": "COVID-19 बुलेटिन",
    "Picture of Daily Rainfall Map": "दैनिक बर्षा को नक्सा",
    "Please click on the image to select files":
      "कृपया फाइलहरू चयन गर्न चित्रमा क्लिक गर्नुहोस्",
    "Baisakh 1 to": "बैशाख १ देखि",
    "Families Affected": "प्रभावित परिवार",
    Total: "जम्मा",
    "Incident Details": "घटना विवरण",
    "No. of Incidents": "घटना संख्या",
    "S.N": "क्र.स",
    Response: "प्रतिकार्य",
    "Provincewise stats till date": "प्रदेश अनुसार हालसम्मको कुल तथ्याङ्क",
    "Incident Summary": "घटना सारांश",
    "Disaster details of the last 24 hours": "२४ घण्टामा विपद्को विवरण",
    "Provincewise Death, Missing and Injured Counts":
      "प्रदेश अनुसार मृत्यु, बेपत्ता र घाइते संख्याको बर्गीकरण",
    "Genderwise Deaths": "लिङ्ग अनुसार मृत्युको बर्गीकरण",
    "COVID-19 details of the last 24 hrs": "२४ घण्टामा COVID-19 को विवरण",
    "Stats till date": "हालसम्मको कुल तथ्याङ्क",
    "Vaccine Stats": "खोपको विवरण",
    "Daily Rain Summary": "दैनिक बर्षाको सारांश",
    "Daily Rainfall Map Description": "दैनिक बर्षाको नक्साको क्याप्शन",
    "Daily Max Temperature Map Description":
      "दैनिक अधिकतम तापक्रम नक्साको क्याप्शन",
    "Daily Min Temperature Map Description":
      "दैनिक न्यूनतम तापक्रम नक्साको क्याप्शन",
    "Daily Max Temperature": "दैनिक अधिकतम तापक्रम",
    "Daily Min Temperature": "दैनिक न्यूनतम तापक्रम",
    Annex: "अनुसूची",
    "Complete details of the incidents": "घटनाको पूर्ण विवरणहरु",
    "For additional info regarding this Bulletin:":
      "दैनिक बुलेटिन सम्भन्धी थप जानकारीको लागि",
    "National Disaster Risk Reduction and Management Authority":
      "राष्ट्रिय विपद् जोखिम न्यूनीकरण तथा व्यवस्थापन प्राधिकरण",
    "GPO Box Number": "पोस्ट बक्स नम्बर",
    Phone: "फोन",
    "For additional info": "थप जानकारीको लागि",
    "Daily Temperature and Rain Summary": "दैनिक बर्षा र तापक्रमको सारांश",
    Male: "पुरुष",
    Female: "महिला",
    "Percentage of 1st Dosage": "पहिलो मात्रा को",
    "First Dosage Count": "पहिलो मात्रा खोप लगाएको संख्या",
    "Second Dosage Count": "दोस्रो मात्रा खोप लगाएको संख्या",
    "Third Dosage Count": "तेस्रो मात्रा खोप लगाएको संख्या",
    totalAffected: "कुल संक्रमित संख्या",
    totalActive: "कुल सक्रिय संक्रमित संख्या",
    totalRecovered: "कुल मृत्‍यु संख्या",
    totalDeaths: "कुल निको भएका संख्या",
    "Total Affected": "कुल संक्रमित संख्या",
    "Total Active": "कुल सक्रिय संक्रमित संख्या",
    "Total Deaths": "कुल मृत्‍यु संख्या",
    "Total Recovered": "कुल निको भएका संख्या",
    "Vaccine-wise total breakdown": "खोप अनुसार अहिले सम्म को कुल तथ्यांक",
    "COVID-19 Stats till date": "हालसम्मको COVID-19 को कुल तथ्याङ्क",
    "COVID-19 Stats for last 24 hours": "२४ घण्टामा COVID-19 को विवरणहरु",
    "Genderwise Breakdown of Deaths": "लिङ्ग अनुसार मृत्‍युको बर्गीकरण",
    "Hazardwise Breakdown of Incidents and Deaths":
      "प्रकोप अनुसार घटना र मृत्‍यु संख्याको बर्गीकरण",
    "Death Count": "मृत्‍यु संख्या",
    "Hazard Legend": "प्रकोप संकेत",
    death: "मृत्यु",
    Death: "मृत्यु",
    missing: "बेपत्ता",
    injured: "घाइते",
    "Province-wise death, missing and injured":
      "प्रदेश अनुसार कुल संक्रमित संख्याको बर्गीकरण",
    "Hazard-wise breakdown of incidents (last 24 hours)":
      "प्रकोप अनुसार घटनाको विवरण (२४ घण्टा) नक्सामा",
    "Disaster Hilights": "विपद्का हाइलाइट",
    "Daily Bipad Bulletin": "दैनिक विपद् बुलेटिन",
    "Nepal Government": "नेपाल सरकार",
    "Ministry of Home Affairs": "गृह मन्त्रालय",
    "Disaster Incidents in last 24 hours": "२४ घण्टामा विपद्का विवरणहरु",
    "Reference Number": "सन्दर्भ नम्बर",
    "Entry Date": "प्रवेश मिति",
    "Expiry Date": "म्याद सकिने मिति",
    "Brand Registration Number": "ब्रान्ड दर्ता नम्बर",
    Orientation: "Orientation",
    "Max value 5000 & Min value 500": "अधिकतम मान ५००० र न्यूनतम मान ५००",
    "File format": "फाइलको ढाँचा",
    Resolution: "Resolution",
    "Resolution Type": "Resolution को प्रकार",
    "Page Type": "पृष्ठको प्रकार",
    Custom: "कस्‍टम",
    "Select Page Type": "पृष्ठ प्रकार चयन गर्नुहोस्",
    "Published by": "प्रकाशक",
    "Published on": "प्रकाशन मिति",
    "BELOW WARNING LEVEL": "चेतावनी तह भन्दा तल",
    "ABOVE WARNING LEVEL": "चेतावनी तह भन्दा माथि",
    "ABOVE DANGER LEVEL": "खतरा तह भन्दा माथि",
    nepal_police: "नेपाल_प्रहरी",
    "Nepal Police": "नेपाल प्रहरी",
    "Search Resources": "स्रोतहरू खोज्नुहोस्",
    "Please select resource list to search":
      "कृपया खोजी गर्न स्रोत सूची चयन गर्नुहोस्",
    "Name and contact number of technical staff":
      "प्राविधिक कर्मचारीहरूको नाम र सम्पर्क नम्बर",
    Scale: "मापन",
    "Total capacity of the open space.":
      "खुल्ला ठाउँ (OpenSpace) को कुल क्षमता",
    "Number of total employee trained in disaster management":
      "विपद् व्यवस्थापनमा तालिम प्राप्‍त कुल कर्मचारीको संख्या",
    "Event On": "घटना घटेको मिति",
    "Air Quality Index": "वायु गुणस्तर सूचकांक",
    "Social Security": "सामाजिक सुरक्षा",
    "Number of households": "घरपरिवारको संख्या",
    Occupation: "पेशा",
    Occupancy: "अधिभोग",
    "Drinking Water": "पिउने पानी",
    "Number of buildings": "भवनहरूको संख्या",
    "Agriculture and Livestock": "कृषि र पशुधन",
    Agriculture: "कृषि",
    "Agriculture Practice": "कृषि अभ्यास",
    "Agricultural Products": "कृषि उत्पादनहरू",
    "Major Agricultural products": "प्रमुख कृषि उत्पादनहरू",
    "Physical Structure of House": "घरको भौतिक संरचना",
    "Majority of building type": "भवन प्रकार को बहुमत",
    "Building by Type of Superstructure": "सुपरस्ट्रक्चरको आधारमा भवनका प्रकार",
    "Majority of building": "भवनको बहुमत",
    "Buildings by Type of Foundation": "फाउन्डेशनको प्रकार अनुसार भवनहरू",

    Migration: "बसाइँ सराई",
    "Education Attainment": "शिक्षा प्राप्‍ति",
    "Household ID": "घरपरिवार आईडी",
    ID: "आईडी",
    "Total Number of family members": "परिवारका सदस्यहरूको कुल संख्या",
    Ethinicity: "जातीय",
    Religion: "धर्म",
    "Sensative Population": "संवेदनशील जनसंख्या",
    "Above 60 years old": "६० वर्षभन्दा माथि",
    "Pregnant Women": "गर्भवती महिला",
    "People With Disability": "अपाङ्गता भएका व्यक्तिहरू",
    "Children Below 5 Years old": "५ वर्ष मुनिका बालबालिका",
    "Building Structure": "भवन संरचना",
    "Age of Building": "भवनको उमेर",
    "Annual Income": "वार्षिक आय",
    "Supporting Occupation": "सहयोगी पेशा",
    "Major Occupation": "प्रमुख पेशा",
    "Economic Aspects": "आर्थिक पक्षहरू",
    "Building Foundation": "बिल्डिंग फाउन्डेशन",
    "Roof Type": "छतको प्रकार",
    "Number of Stories": "तलाको संख्या",
    Language: "भाषा",
    "GENERATE REPORT": "प्रतिवेदन प्रकाशन गर्न यहाँ क्‍लिक गर्नुहोस्।",
    "Select Date": "मिति चयन गर्नुहोस्",
    About: "बारे",
    "Report Type": "रिपोर्ट प्रकार",
    "NepDat Profile": "NepDat प्रोफाइल",
    "Edit Document": "कागजात सम्पादन गर्नुहोस्",
    "Add Document": "कागजात थप्नुहोस्",
    "Add document": "कागजात थप्नुहोस्",
    "Viz Risk": "भिज-रिश्‍क",
    IBF: "आइ.बि.यफ",
    "Published Date": "प्रकाशित मिति",
    "Published By": "प्रकाशक",
    "No Description Available": "कुनै विवरण उपलब्ध छैन",
    "Duration in Days": "अवधिमा दिनहरू",
    "Contact Training": "सम्पर्क प्रशिक्षण",
    "Add Training": "तालिम थप्नुहोस्",
    "Previous Image": "अघिल्‍लो फोटो",
    "Is DRR Focal Person": "के विपद सम्पर्क व्यक्ति हो",
    "Work Number": "कार्य नम्बर",
    "Mobile Number": "मोबाइल नम्बर",
    Committee: "समिति",
    "Community Address": "सामुदायिक ठेगाना",

    "Edit Contact": "सम्पर्क सम्पादन गर्नुहोस्",
    "SEARCH BY POSITION": "पद अनुसार खोज्नुहोस्",
    "Add Contact": "सम्पर्क थप्नुहोस्",
    Committe: "समिति",
    Action: "एक्सन",
    Position: "पद",
    "No Training Attained": "कुनै तालिम प्राप्‍त नगरेको",
    "Contact Personals": "सम्पर्क व्यक्तिहरू",
    Budget: "बजेट",
    "SEARCH BY TITLE": "शीर्षक द्वारा खोज्नुहोस्",
    "Table View": "तालिका दृश्य",
    "List View": "सूची दृश्य",
    "S/N": "क्रम नं.",
    Organization: "संस्‍था",
    "Add Organization": "संस्‍था थप्नुहोस्",
    "Edit Organization": "संस्‍था सम्पादन गर्नुहोस्",
    Project: "परियोजना",
    "Budget(USD)": "बजेट (USD)",
    StockIn: "स्टक भित्र",
    StockOut: "स्टक बाहिर",
    "No Data Available": "कुनै डाटा उपलब्ध छैन",
    Value: "मान",
    Percentage: "प्रतिशत",
    Years: "वर्ष",
    "Select Data Format": "डाटा ढाँचा चयन गर्नुहोस्",
    "Download Csv": "Csv डाउनलोड गर्नुहोस्",
    "Literacy Rate": "साक्षरता दर",
    "Population By Age Group": "उमेर समूह द्वारा जनसंख्या",
    "Household Statistics": "घरधुरी तथ्याङ्क",
    "Literacy Rate (%)": "साक्षरता दर (%)",
    Rate: "दर",
    "Short Description": "छोटो विवरण",
    "Gender Breakdown": "लिङ्ग वर्गीकरण",
    "Download Chart": "चार्ट डाउनलोड गर्नुहोस",
    "Demography (Census 2011)": "जनसांख्यिकी (जनगणना २०११)",
    Demography: "जनसांख्यिकी",
    Visualization: "Visualization",
    Demographics: "जनसांख्यिकी विवरण",
    "NEP-DAT Profile": "NEP-DAT प्रोफाइल",
    Flow: "प्रवाह",
    "Water Level": "पानीको तह",
    "Hourly Water Level": "प्रति घण्टा पानी स्तर",
    "Danger Level": "खतरा स्तर",
    "Access to communication": "सञ्चारमा पहुँच",
    "Access to Safe Shelter": "सुरक्षित आश्रयमा पहुँच",
    "DRR training received": "DRR तालिम प्राप्त भयो",
    "Access to Early Warning Information": "प्रारम्भिक चेतावनी जानकारीमा पहुँच",
    "Measured On": "मापन गरिएको मिति",
    "Latest Rainfall": "पछिल्‍लो वर्षा",
    "Average Weekly Rainfall": "औसत साप्‍ताहिक वर्षा",
    "Average Daily Rainfall": "औसत दैनिक वर्षा",

    "Edit data": "डाटा सम्पादन गर्नुहोस्",
    "View Details": "विवरणहरू हेर्नुहोस्",
    Inventories: "आविष्कारहरू",
    "Capacity and Resources": "श्रोत तथा क्षमता",
    "loading legend...": "लेजेन्‍ड लोड गर्दै...",
    Opacity: "अस्पष्टता",
    Year: "वर्ष",
    temperature: "तापक्रम",
    precipitation: "वर्षा",
    Measurement: "मापन",
    "Time period": "समय अवधि",
    Scenario: "परिदृश्य",
    "Precipitation data": "वर्षा डेटा",
    "Temperature data": "तापक्रम डेटा",
    "Show National Data": "राष्ट्रिय डाटा देखाउनुहोस्",
    "Links from Climate Scenarios from Nepal (NAP)":
      "नेपालबाट जलवायु परिदृश्य (NAP) को लिङ्कहरू",
    tole: "टोल",
    "owner gender": "मालिकको लिंग",
    "Climate change": "जलवायु परिवर्तन",
    Layers: "तहहरू",
    "Show visualizations": "Visualizations हेर्नुहोस",
    DATASET: "डाटासेट",
    VISUALIZATION: "भिजुअलाइजेशन",
    "Layer details": "तह विवरण",
    "Toggle opacity input visibility": "अस्पष्टता इनपुट दृश्यता टगल गर्नुहोस्",
    "Toggle legend visiblity": "लेजेन्ड दृश्यता टगल गर्नुहोस्",
    "Active layers": "सक्रिय तहहरू",
    Preprimary: "प्राथमिक",
    Hospital: "अस्पताल",
    "Env. Pollution": "वातावरणीय प्रदूषण",
    "Incident Feedbacks": "घटना प्रतिकार्यहरू",
    "Not provided": "प्रदान गरिएको छैन",
    "Access Points": "पहुँच बिन्दुहरू",
    "Basic Health Care Center": "आधारभूत स्वास्थ्य सेवा केन्द्र",
    "Community Health Unit": "सामुदायिक स्वास्थ्य इकाई",
    "Ayurveda Hospital": "आयुर्वेद अस्पताल",
    "Poly Clinic": "पोली क्लिनिक",
    "General Hospital": "सामान्य अस्पताल",
    Clinic: "क्लिनिक",
    "Urban Health Center": "शहरी स्वास्थ्य केन्द्र",
    Cooperative: "सहकारी",
    "Micro Credit Development": "माइक्रो क्रेडिट विकास",
    "Basic Education": "आधारभूत शिक्षा",
    "Pre Primary": "पूर्व प्राथमिक",
    College: "कलेज",
    Government: "सरकार",
    "Add Unit": "एकाइ थप्नुहोस्",
    "Add Cluster": "क्लस्टर थप्नुहोस्",
    "Edit Cluster": "क्लस्टर सम्पादन गर्नुहोस्",
    "Edit Unit": "एकाइ सम्पादन गर्नुहोस्",
    Unit: "एकाइ",
    mm: "मिमि",
    Confidence: "निर्धक्क",
    "Home Page": "गृह पृष्ठ",
    "Download Map": "डाउनलोड गर्नुहोस्",
    "Download with default settings":
      "पूर्वनिर्धारित सेटिङहरूसँग डाउनलोड गर्नुहोस् ",
    "Download with custom settings": "अनुकूलन सेटिङहरूसँग डाउनलोड गर्नुहोस्",
    Streamflow: "नदीको बहाब",
    "No legends to display": "प्रदर्शन गर्न कुनै पौराणिक कथाहरू छैनन्",
    "Below Warning Level": "चेतावनी तहभन्दा तल",
    "Warning Level": "चेतावनी स्तर",
    "Above Warning Level": "चेतावनी स्तरभन्दा माथि",
    "Above Danger Level": "खतराको स्तरभन्दा माथि",

    "Below Warning Level and Steady": "चेतावनी तह र स्थिर",
    "Below Warning Level and Rising": "चेतावनी स्तरभन्दा तल र बढ्दै",
    "Below Warning Level and Falling": "चेतावनी स्तर तल र झर्दै",
    "Above Warning Level and Steady": "चेतावनी स्तर माथि र स्थिर",
    "Above Warning Level and Rising": "चेतावनी स्तर माथि र बढ्दै",
    "Above Warning Level and Falling": "चेतावनीको माथिल्लो तह र गिरावट",
    "Above Danger Level and Steady": "खतराको स्तर माथि र स्थिर",
    "Above Danger Level and Rising": "खतराको स्तर माथि र बढ्दै",
    "Above Danger Level and Falling": "खतराको स्तर माथि र झर्दै",
    "Add Category": "श्रेणी थप्नुहोस्",
    "Edit Category": "श्रेणी सम्पादन गर्नुहोस्",
    "Citizen Reports": "नागरिक रिपोर्ट",
    "Economic Loss": "आर्थिक घाटा",
    "Owner Name": "घरमुलि को नाम",
    "Add Livestock Loss": "पशु चौपाया क्षेति थप्नुहोस्",
    "Add Family Loss": "पारिवारिक क्षेति थप्नुहोस्",
    "Add / edit incident": "घटना थप्नुहोस् / सम्पादन गर्नुहोस्",
    Age: "उमेर",
    Gender: "लिङ्ग",
    "Below Poverty": "गरिबी मुनि",
    Count: "गणना गर्नुहोस्",
    Nationality: "राष्ट्रियता",

    "Add People Loss": "मानवीय क्षेति थप्नुहोस्",
    "Are you sure you want to delete this item?":
      "के तपाइँ यो वस्तु मेटाउन निश्चित हुनुहुन्छ?",
    Cause: "कारण",
    "Reported on": "रिपोर्ट गरिएको मिति",
    Approved: "स्वीकृत छ?",
    "Need Followup": "फलोअप चाहिन्छ?",
    "Verification Message": "प्रमाणीकरण सन्देश",

    "Stockpile Items": "भण्डार वस्तुहरू",
    Search: "खोज्नुहोस्",
    Item: "वस्तु",
    Items: "वस्तुहरू",
    Categories: "कोटीहरू",
    Clusters: "क्लस्टरहरू",
    Quantity: "मात्रा",
    Operator: "अपरेटर",
    "Inventory Details": "सूची विवरण",
    "Health Post": "हेल्थपोष्ट",
    "Primary Health Care Center": "प्राथमिक स्वास्थ्य सेवा केन्द्र",
    "Development Bank": "विकास बैंक",
    Commercial: "व्यापारिक",
    "High School": "उच्‍च विद्यालय",

    "Get direction": "दिशा प्राप्‍त गर्नुहोस्",
    Resources: "स्रोतहरू",
    Resource: "स्रोत",
    TransferToResource: 'स्रोतहरू स्थानान्तरण',
    "People Dead": "मान्‍छे मृत्‍यु संख्‍या",
    "Livestock Destroyed": "पशुचौपाया क्षति",
    "Infrastructures Destroyed": "पूर्वाधारको क्षति",
    "Estimated Loss (NRs.)": "अनुमानित क्षति (रु.)",
    Yes: "हो",
    No: "होईन",
    Loss: "घाटा",
    "Are you sure you want to delete this incident?":
      "के तपाइँ यो घटना मेटाउन निश्चित हुनुहुन्छ?",
    "Reported On": "रिपोर्ट गरिएको मिति",
    Wards: "वार्डहरू",
    "Leave Feedback": "सुझाव दिनुहोस्",
    Email: "इमेल",
    "Mobile number": "मोबाइल नम्बर",
    Comment: "टिप्पणी",
    "There are no incidents at the moment.": "अहिले कुनै घटना छैन।",
    "Metropolitan City": "महानगरपालिका",
    "Submetropolitan City": "उप-महानगरपालिका",
    "Rural Municipality": "गाउँपालिका",
    "Are you sure to delete the Alert?":
      "के तपाइँ अलर्ट मेटाउन निश्चित हुनुहुन्छ?",
    "Add / edit alert": "अलर्ट थप्नुहोस् / सम्पादन गर्नुहोस्",
    "Started on": "सुरु भएको गते र समय",
    "Expires on": "म्याद सकिने गते र समय",
    Public: "सार्वजनिक",
    "Are you sure you want to close the form?":
      "के तपाईं फारम बन्द गर्न चाहनुहुन्छ ?",
    Confirm: "पुष्टि गर्नुहोस्",
    Cancel: "रद्द गर्नुहोस्",
    Ok: "ठिक छ",

    "Shapefile needs to be uploaded first..":
      "Shapefile पहिले अपलोड गर्न आवश्यक छ .. ",
    "Upload cover image:": "कभर ईमेज अपलोड गर्नुहोस्:",
    Workspace: "कार्यक्षेत्र",
    "Layer Name": "तहको नाम",
    "Geoserver URL": "जियोसर्भर URL",
    "Add shape file(.zip extension)": "shape file थप्नुहोस् (.zip extension)",

    "Save and Continue": "Save and Continue",
    Elevation: "उचाई ",
    "Total Area": "कुल क्षेत्रफल",
    "Usable Area": "प्रयोगयोग्य क्षेत्र",
    Address: "ठेगाना",
    "Current Land Use": "हालको भू-उपयोग ",
    "Capacity of Community Space": "सामुदायिक ठाउँको क्षमता",
    "Used for emergency landing as helipad?":
      "के हेलिप्याडको आपतकालीन अवतरणको लागी प्रयोग गरिन्‍छ?",
    "Is drinking water facility available?": "के पिउने पानी उपलब्ध छ?",
    "What other facilities are available? Please specify.":
      "अन्य सुविधा उपलब्ध छ भने, यहाँ उल्लेख गर्नुहोस्",
    remarks: "टिप्पणीहरू",
    attachment: "संलग्नक",
    "Edit Item": "वस्तु सम्पादन गर्नुहोस्",
    "Add Item": "वस्तु थप्नुहोस्",
    "Title Nepali": "नेपाली शीर्षक",

    "Operated By": "द्वारा संचालित",
    "Is the facility single story or multi story?":
      "के सुविधा एकतले वा बहुतले हो?",
    "Number of people that can be accommodated": "बस्न मिल्ने मनिसको संख्या",
    "Use of evacuation center, please specify":
      "निकासी केन्द्रको प्रयोग, कृपया उल्‍लेख गर्नुहोस",
    "Is drinking water available?": "के पिउने पानी उपलब्ध छ ?",
    "Is toilet available?": "के शौचालय उपलब्ध छ ?",
    "How many toilets are available?": "कति वटा शौचालय उपलब्ध छन्?",
    "How Many Toilets Are Available?": "कति वटा शौचालय उपलब्ध छन्?",
    "Does the facility have hand washing facility?":
      "के हात धुनी सुबिधा उपलब्ध छ ?",
    "How many hand washing facility is available?":
      "कतिवटा हात धुने सुविधा उपलब्ध छ?",
    "Is food preparation facility available?": "के खाना बनाउन उपलब्ध छ? ",
    "How many food preparation facility is available?":
      "कतिवटा खाना तयार गर्ने सुविधा उपलब्ध छ?",
    "Is sleeping facility available such as bed/cot/mat?":
      "के सुत्‍नका लागि सुविधा उपलब्ध छ ? (खाट, चटाई आदि) ",
    "How many sleeping facility is available?": "सुत्‍ने सुविधा कति छ ?",
    "Please specify Disable Friendly Infrastructures":
      "अपांग मैत्री पूर्वाधारहरू छ भने उल्‍लेख गर्नुहोस",

    "Name of Focal Person": "फोकल व्यक्तिको नाम",
    "Contact Information of Focal Person": "फोकल व्यक्तिको सम्पर्क",
    "Number of trained employee": "प्रशिक्षित कर्मचारीको संख्या",
    "Is safety equipment available?": "के सुरक्षा उपकरण उपलब्ध छ ?",
    "Are there multiple municipalities that share the services from the firefighting apparatus?":
      "के नगरपालिकाले अरु पालिकासंग आगो निभाउने उपकरणको सहयोग अदान प्रदान गर्छ?",
    "Capacity (Litre)": "क्षमता (लिटर)",
    "Vehicle Number": "गाडी नम्बर",
    "Driver's Name": "चालकको नाम",
    "Driver's Contact Number": "चालकको सम्पर्क नम्बर",
    "Driver’s Alternative Number": "चालकको वैकल्पिक नम्बर",
    "Condition of Fire fighting apparatus": "आगो निभाउने उपकरणको स्थिति",

    "Select either you are entering the details of vehicle center such as bus parks and stops or vehicle committee.":
      "तपाईंले बस पार्क र स्टपहरू वा सवारी समिति जस्ता सवारी साधन केन्द्रको विवरणहरू प्रविष्ट गरिरहनुभएको छ कि त चयन गर्नुहोस्।",
    "Number of transportation facilities": "यातायत साधनको संख्या",
    "Are disable friendly vehicle available?":
      "अपांग मैत्री यातायतको साधन उपलब्ध छ? ",
    "Is the building designed following building code?":
      "के भवन निर्माण building  code  अनुसार डिजाइन गरिएको हो?",
    "Disable Friendly Vehicle types and count available?":
      "अपांग मैत्री यातायतको साधनको प्रकार र गणना उपलब्ध छ?",
    Code: "कोड",
    "Select the condition of boats": "डुङ्गा को अवस्था चयन गर्नुहोस्",

    "Area of airport(Sq Km)": "एरपोर्टको क्षेत्रफल (वर्ग किमि)",
    "Does the facility have humanitarian staging area?":
      "के मानवीय सहायता स्थल छ?",
    "Please specify,Disable friendly infrastructures":
      "भौतिक पूर्वाधार अपांगमैत्री भएमा उल्‍लेख गर्नुहोस",

    "Placement of Tank": "ट्यांक को स्थान",
    "Source of Water": "पानीको स्रोत",
    "Is electricity needed to pump water?": "पानी पम्प गर्न बिजुली चाहिन्छ?",
    "When system was build?": "प्रणाली कहिले निर्माण भयो?",
    "Does the facility have technical staff?": "के प्राविधिक कर्मचारीहरु छन्? ",
    "Is the water supply infrastructure operational?":
      "के खानेपानीको पूर्वाधार संचालनमा छ?",

    Area: "क्षेत्रफल ",
    "Is it Permanent?": "के यो स्थायी हो? ",
    "If the facility is public toilet, number of toilet available":
      "यदि सुविधा सार्वजनिक शौचालय हो भने,शौचालयको संख्या उल्लेख गर्नुहोस्",
    "If the facility is public toilet, number of male toilet available":
      "यदि सुविधा सार्वजनिक शौचालय हो भने, पुरुष शौचालयको संख्या उल्लेख गर्नुहोस् ",
    "If the facility is public toilet, number of female toilet available":
      "यदि सुविधा सार्वजनिक शौचालय हो भने, महिला शौचालयको संख्या उल्लेख गर्नुहोस्",
    "If the facility is public toilet, number of common toilet available":
      "यदि सुविधा सार्वजनिक शौचालय हो भने, साझा शौचालयको संख्या उल्लेख गर्नुहोस्",
    "If the facility is public toilet, number of tabs available":
      "यदि सुविधा सार्वजनिक शौचालय हो भने, धाराहरूको संख्या उल्लेख गर्नुहोस्",

    "Status?": "स्थिति?",
    "Capacity (In Megawatt)": "क्षमता (Megawatt मा)",
    Promoter: "प्रवर्द्धक",

    "From When was the bridge operational?": "पुल कहिलेदेखि संचालनमा आएको हो ?",
    "Is the bridge motorable?": "के पुल गाडी चल्न योग्य छ?",
    "Length (in meter)": "लम्बाई (मीटरमा)",
    "Width (in meter)": "चौडाई (मीटरमा) ",
    "Condition of Bridge?": "पुलको अवस्था?",
    "How many lane does the bridge have?": "यदि छ भनी कति lane को बाटो छ? ",
    "Upload Document": "फाइल अपलोड गर्नुहोस्",
    "Operating Date": "संचालन भएको मिति ",
    Ownership: "स्वामित्व",
    "Is the helipad build following the standard operational guidelines, 2075 of Civil Aviation Authority of Nepal?":
      "के हेलिप्याड नेपाल नागरिक उड्डयन प्राधिकरण को मानक परिचालन दिशानिर्देश, २०७५  को पालना गरी बनेको हो?",
    "Area of Helipad(sq m)": "हेलिप्याडको क्षेत्र(वर्ग मीटर))",
    Altitude: "उचाई",
    "HELIPAD DETAILS": "हेलिप्याडको  विवरण",
    "Surface Level": "सतह स्तर",
    "Surface Type": "सतहको प्रकार",
    "Add Stock In": "स्टक भित्र थप्नुहोस्",
    "Edit Stock In": "स्टक भित्र सम्पादन गर्नुहोस्",
    "Add Stock Out": "स्टक बाहिर थप्नुहोस्",
    "Edit Stock Out": "स्टक बाहिर सम्पादन गर्नुहोस्",
    "Has Road Access?": "के सडकको  पहुँच छ ?",
    "Has Storage Facility Available?": "के भण्डारण सुविधा उपलब्ध छ ?",
    "Has Internet Facility Available?": "के इन्टरनेट सेवा उपलब्ध छ ?",
    "Has Wind Direction Indicator Available?": "के हावा दिशा सूचक उपलब्ध छ ?",
    "Has Heli Marker Available?": "के हेली मार्कर उपलब्ध छ ?",
    "Has Night lighting Available?": "के रातको प्रकाश उपलब्ध छ ??",
    "Condition Of Helipad?": "हेलिप्याडको अवस्था?",
    "Name of focal person": "फोकल व्यक्तिको नाम",
    "Contact of focal person": "फोकल व्यक्तिको सम्पर्क",

    "Name of the tower (Radio tower)": "टावरको नाम (रेडियो टावर)",
    "Average coverage radius in km": "औसत कभरेज Radius (KM)",
    "Frequency in megahertz": "मेगाहेर्ट्जमा frequency ",
    "Does the facility have internet service available?":
      "के इन्टरनेट सेवा उपलब्ध छ?",

    "Does the facility have electricity facility?":
      "के बिधुतको सुविधा उपलब्ध छ?",
    "If other facilities are available, please specify.":
      "अन्य सुविधा उपलब्ध छ भने,कृपया उल्‍लेख गर्नुहोस‍ ।",
    "Number of cots available": "उपलब्ध खाटहरूको संख्या",
    "Number of mats available": "उपलब्ध चटाईहरूको संख्या",
    "Has sleeping facility available?": "के सुत्‍‍नका लागि सुविधा उपलब्ध छ ?",
    "Does the facility have WASH facility?":
      "के स्वच्छता (WASH) सुबिधा उपलब्ध छ ?",
    "Is toilet available? ": "के शौचालय उपलब्ध छ?",
    "Is drinking water available? ": "के पिउने पानी उपलब्ध छ?",

    "Number of rooms": "कोठाको संख्या",
    "Number of beds": "बेडको संख्या",
    "Number of Beds": "बेडको संख्या",
    "Number of Service Users": "सेवा प्रयोगकर्ताहरू",
    "SERVICES AVAILABLE": "सेवा प्रकार",
    "Facility Type": "सुविधा प्रकार",
    "Does the facility have disaster management unit available?":
      "के यहाँ विपद व्यवस्थापन इकाई छ?",
    "Has employee trained in disaster management?":
      "के यहाँका कर्मचारीहरु ले विपद व्यवस्थापन सम्बन्धित तालिम प्राप्‍त छन् ? ",
    "Does the institution has helipad?":
      "के यस संस्थामा helipad आबतरण सुबिधा छ ?",
    Bank: "बैंक",
    "Money Exchange": "मुद्रा विनिमय (Money exchange )",
    ATM: "एटीएम (ATM)",
    Other: "अन्य",
    other: "अन्य",
    "Other Services": "Other Services",
    "Number of Male Employee": "पुरुष कर्मचारीको संख्या",
    "Number of Female Employee": "महिला कर्मचारीको संख्या",
    "Number of Other Employee": "अन्य कर्मचारीको संख्या",
    "Total Number of Employee": "कुल कर्मचारीको संख्या",

    "Please specify HF Code": "Please specify HF Code",
    Authority: "Authority",
    "Authority Level": "Authority Level",
    OwnerShip: "OwnerShip",
    "Service Type": "Service Type",
    "Operational Status": "Operational Status",
    "Number of available bed ": "Number of available bed ",
    "Hospital Bed": "Hospital Bed",
    "ICU Bed": "ICU Bed",
    "Ventilator Bed": "Ventilator Bed",
    "Child Immunization": "Child Immunization",
    "TD Vaccination": "TD Vaccination",
    "Vaccination facility": "Vaccination facility",
    "Integrated Management of Neonatal and Childhood Illness (IMNCI)":
      "Integrated Management of Neonatal and Childhood Illness (IMNCI)",
    "Growth Monitoring": "Growth Monitoring",
    "Safe Motherhood": "Safe Motherhood",
    "Antenatal Care": "Antenatal Care",
    "Postnatal Care": "Postnatal Care",
    "Birthing/Delivery Services": "Birthing/Delivery Services",
    "Basic Emergency Obstetric Care (BEOC)":
      "Basic Emergency Obstetric Care (BEOC)",
    "Comprehensive Emergency Obstetric Care (CEOC)":
      "Comprehensive Emergency Obstetric Care (CEOC)",
    "Comprehensive Abortion Care": "Comprehensive Abortion Care",
    "Post Abortion Care": "Post Abortion Care",
    "Family planning": "परिवार नियोजन",
    "Condom/Pills/Depo-Provera": "कन्डम/चक्की/डेपो-प्रोभेरा",
    IUCD: "IUCD",
    Implant: "Implant",
    Vasectomy: "Vasectomy",
    Minilap: "Minilap",
    OPD: "OPD",
    General: "General",
    Pediatric: "Pediatric",
    "Obs. and Gynae": "Obs. and Gynae",
    Surgery: "Surgery",
    Gastrointestinal: "Gastrointestinal",
    Cardiac: "Cardiac",
    Mental: "Mental",
    Respiratory: "Respiratory",
    Nephrology: "Nephrology",
    ENT: "ENT",
    Dermatology: "Dermatology",
    Endocrinology: "Endocrinology",
    Oncology: "Oncology",
    Neurology: "Neurology",
    Ophthalmology: "Ophthalmology",
    "Treatment of Tuberculosis": "Treatment of Tuberculosis",
    "Treatment of Multi-drug resistance (MDR) tuberculosis":
      "Treatment of Multi-drug resistance (MDR) tuberculosis",
    "Treatment of Leprosy": "Treatment of Leprosy",
    "Treatment of Malaria": "Treatment of Malaria",
    "Treatment of Kala-azar": "Treatment of Kala-azar",
    "Treatment of Japanese Encephalitis": "Treatment of Japanese Encephalitis",
    "Laboratory Service": "Laboratory Service",
    "HIV test": "HIV test",
    "Malaria test": "Malaria test",
    "Tuberculosis test": "Tuberculosis test",
    "Kala-azar test": "Kala-azar test",
    "Urine RE": "Urine RE",
    "Stool RE": "Stool RE",
    "General Blood CBC": "General Blood CBC",
    Culture: "Culture",
    Hormones: "Hormones",
    "Leprosy Smear test": "Leprosy Smear test",
    "COVID PCR": "COVID PCR",
    "COVID Antigen": "COVID Antigen",
    "Volunteer Counseling Test (VCT) for HIV/AIDS":
      "Volunteer Counseling Test (VCT) for HIV/AIDS",
    "Prevention of mother-to-child transmission (PMTCT)":
      "Prevention of mother-to-child transmission (PMTCT)",
    "Anti-retro Viral Treatment": "Anti-retro Viral Treatment",
    Dental: "Dental",
    "In Patient": "In Patient",
    Radiology: "Radiology",
    "X-ray": "एक्स-रे",
    "X-ray with contrast": "X-ray with contrast",
    Ultrasound: "Ultrasound",
    Echocardiogram: "Echocardiogram",
    ECG: "ECG",
    Trademill: "Trademill",
    "CT Scan": "CT Scan",
    MRI: "MRI",
    Endoscopy: "Endoscopy",
    Colonoscopy: "Colonoscopy",
    "Surgical Service": "Surgical Service",
    "Caesarian Section": "Caesarian Section",

    "Gastro Intestinal": "Gastro Intestinal",
    "Trauma Surgery": "Trauma Surgery",
    "Cardiac Surgery": "Cardiac Surgery",
    "Neuro Surgery": "Neuro Surgery",
    "Plastic Surgery": "Plastic Surgery",
    "Specialized Service": "Specialized Service",
    ICU: "आईसीयू",
    CCU: "CCU",
    NICU: "एनआईसीयू",
    MICU: "MICU",
    SNCU: "SNCU",
    PICU: "PICU",
    "Cardiac Catheterization": "Cardiac Catheterization",
    Physiotherapy: "Physiotherapy",
    "Ambulance services": "Ambulance services",
    "Extended Health Service": "Extended Health Service",
    "Geriatric Ward": "Geriatric Ward",
    Pharmacy: "फार्मेसी",
    OCMC: "OCMC",
    "Health Insurance": "Health Insurance",
    SSU: "SSU",
    "Ayurveda Service": "Ayurveda Service",
    "COVID Clinic Service": "COVID Clinic Service",
    "Emergency services": "Emergency services",
    "Operating theatre": "Operating theatre",
    "Blood donation": "Blood donation",
    "LISTED FOR FREE TREATMENT BIPANNA": "LISTED FOR FREE TREATMENT BIPANNA",
    "Kidney Dialysis": "Kidney Dialysis",
    "Kidney Transplant": "Kidney Transplant",
    "Medication After Kidney Transplant": "Medication After Kidney Transplant",
    "Head Injury": "Head Injury",
    "Spinal Injury": "Spinal Injury",
    Alzheimer: "Alzheimer",
    Cancer: "Cancer",
    Heart: "Heart",
    Parkinson: "Parkinson",
    "Number Of Male Employee": "पुरुष कर्मचारीको संख्या",
    "Number Of Female Employee": "महिला कर्मचारीको संख्या",
    "Number Of Other Employee": "अन्य कर्मचारीको संख्या",
    "Total Number Of Employee": "कुल कर्मचारीको संख्या",
    specialization: "विशेषज्ञता",
    "Last Renewal Date": "Last Renewal Date",
    "Date of Validity": "Date of Validity",
    "Is the facility designed following building codes?":
      "के भवन building code पालना गरि निर्माण गरिएको हो?",

    "Does the institution have helipad facility?":
      "के स्वास्थ्य संस्थामा helipad अबतरण सुबिधा छ ? ",
    "Does the institution have evacuation route?":
      "के स्वास्थ्य संस्थामा evacuation route छ?",
    "Does the institution have disaster focal point person?":
      "के स्वास्थ्य संस्थामा Disaster फोकल point तोकेएको छ?",
    "Disaster Focal Person Name": "Disaster Focal Person Name",

    "Focal Person Contact Number": "Focal Person Contact Number",
    "Does the institution has open space?":
      "Does the institution has open space?",
    "Does the institution has medical storage space?":
      "Does the institution has medical storage space?",
    "Does the institution have electricity backup?":
      "Does the institution have electricity backup?",
    "Remarks on Opening Hours": "खुल्ने समयमा टिप्पणी भए ",

    "Operator Type": "अपरेटरको प्रकार",
    "Please specify operator type": "अपरेटर प्रकार चयन गर्नुहोस्",
    "Number of Classrooms": "कक्षा कोठा गणना",
    "Area Of School (Sq.Km)": "विद्यालयको क्षेत्रफल कति छ?",

    "NUMBER OF EMPLOYEES": "कर्मचारीको संख्या",
    "Number of Female Employees": "महिला कर्मचारीको संख्या",
    "Number of Male Employees": "पुरुष कर्मचारीको संख्या",
    "Number of Other Employees": "अन्य कर्मचारीको संख्या",
    "Total Number of Employees": "कुल कर्मचारी संख्या",
    "Number of Differently-abled Male Employees": "पुरुष कर्मचारीको संख्या",
    "Number of Differently-abled Female Employees":
      "फरक क्षमता भएको महिला कर्मचारीको संख्या",
    "Number of Differently-abled Other Employees":
      "फरक क्षमता भएको अन्य कर्मचारीको संख्या",
    "NUMBER OF STUDENTS": "विद्यार्थीको संख्या",
    "Number of Male Students": "पुरुष विद्यार्थीको संख्या",
    "Number of Female Students": "महिला विद्यार्थीको संख्या",
    "Number of Other Students": "अन्य विद्यार्थीको संख्या",
    "Total Number of Students": "कुल विद्यार्थीको संख्या",
    "Number of Differently-abled Male Students":
      "फरक क्षमता भएको पुरुष विद्यार्थीको संख्या",
    "Number of Differently-abled Female Students":
      "फरक क्षमता भएको महिला विद्यार्थीको संख्या",
    "Number of Differently-abled Other Students":
      "फरक क्षमता भएको अन्य विद्यार्थीको संख्या",
    "STUDENT AGE GROUP": "विद्यार्थीहरूको उमेर समूह",
    "Less than 10 years": "१० बर्ष भन्दा कम",
    "Between 10-15 years": "१०-१५ वर्षको बीचमा",
    "Between 15-20 years": "१५-२० वर्षको बीचमा",
    "Above 20 years": "२० बर्ष भन्दा माथि",
    "DISASTER MANAGEMENT": "विपद व्यवस्थापन सम्बन्धि ",
    "Is the school designed following building codes?":
      "के विद्यालय building code पालना गरि निर्माण गरिएको हो? ",
    "Remarks on Building Code": "भवन संहिता मा टिप्पणी",
    "Does the facility have open space?": "के भवनमा खुल्ला ठाउँ (OpenSpace) छ?",
    "Area of Open Space (Sq.Km)": "यदी छ भने, खुल्ला ठाउँको क्षेत्रफल कति छ?",
    "Does the facility have disabled friendly infrastructure?":
      "के भवनमा अपांग मैत्री पूर्वाधार निर्माण गरिएका छन्?",
    "Disable Friendly Infrastructures": "यदी, छ भने, यहाँ उल्लेख गर्नुहोस्र ।",
    "Does the facility have evacuation route?": "के भवनमा evacuation route छ?",
    "Does the school have disaster committee or/and other related clubs?":
      "के विद्यालयमा विपद व्यवस्थापन समिति या अन्य कुनै सम्बन्धित समिति छ? ",
    "Disaster Management committee or related Clubs":
      "Disaster Management committee or related Clubs",
    "Has disaster related awareness and training programs been conducted within the school?":
      "के विद्यालयमा विपद व्यवस्थापन सम्बधित सचेतेना तथा तालिम कार्यक्रम आयोजना गरिएको छ? ",
    "Name of Disaster related awareness and training program conducted within the school.":
      "Name of Disaster related awareness and training program conducted within the school.",
    "Does the school provide disaster related education to students?":
      "के विद्यालयले विपद व्यवस्थापन सम्बधि शिक्षा प्रदान गर्छ?",
    "Disaster related education provided by school":
      "Disaster related education provided by school",
    "Does the school have health center and/or psycho-counseling?":
      "के विद्यालयमा स्वास्थ्य केन्द्र वा साइको-परामर्श केन्द्र छ?",
    "OPENING HOUR": "खुल्ने समय",
    "Start Time": "सुरुहुने समय",
    "End Time": "बन्द हुने समय",
    "Remarks on opening hours": "खुल्ने समयमा टिप्पणी भए ",
    "Phone Number": "फोन नम्बर",
    "Email Address": "इ-मेल ठेगाना",
    Website: "वेबसाइट",
    "Local Address": "स्थानीय ठेगाना",
    CONTACT: "सम्पर्क विवरण",

    "Resource Type": "स्रोत प्रकार",
    "INSTITUTION DETAILS": "संस्था विवरण",
    "GENERAL DETAILS": "सामान्य विवरण",
    Name: "नाम",
    "Submit Changes": "परिवर्तनहरू पेश गर्नुहोस्",
    "Add Resource": "स्रोत थप्नुहोस्",

    Clear: "खाली गर्नुहोस्",
    "There are no alerts at the moment.": "अहिले कुनै अलर्टहरू छैनन्।",
    "Hotel and Restaurant": "होटल र रेस्टुरेन्ट",
    Person: "व्यक्ति",
    Beneficiary: "लाभार्थी",
    "Beneficiary Other": "अन्य लाभार्थी",
    "Search for an option": "विकल्प खोज्नुहोस्",
    Title: "शीर्षक",
    "Short Name": "नाम",
    "Long Name": "पुरा नाम",
    "Incident Verification Duration": "घटना प्रमाणीकरण अवधि",

    "Receiver Organization": "प्राप्‍तकर्ता संस्‍था",
    "Provider Organization": "प्रदायक संस्‍था",
    Amount: "रकम",
    Type: "प्रकार",
    Event: "घटना",
    "Fiscal Year": "वित्तीय वर्ष",
    Date: "मिति",
    Save: "सुरक्षित गर्नुहोस",
    "Transfer to Resource": "स्रोतमा हस्तान्तरण",
    Releases: "रिलीजहरू",
    "New Release": "नयाँ रिलीजहरू",
    "Add Release": "विज्ञप्ति थप्नुहोस्",
    "Add Flow": "प्रवाह थप्नुहोस्",
    Flows: "प्रवाहहरु",
    "New Flow": "नयाँ प्रवाह",
    "Close Modal": "मोडल बन्‍द गर्नुहोस",
    Documents: "कागजात",
    "New document": "नयाँ कागजात थप्न",
    "Nothing to show.": "देखाउन को लागी केहि छैन।",
    Category: "श्रेणी",
    "Date of publication": "प्रकाशन मिति",
    "Are you sure you want to delete this document?":
      "के तपाइँ यो कागजात मेटाउन निश्चित हुनुहुन्छ?",

    "Contact personnels": "सम्पर्क कर्मचारीहरू",
    "No. of Projects": "परियोजनाहरूको संख्या",
    "No. of projects": "परियोजनाहरूको संख्या",
    "priority area": "प्राथमिकता क्षेत्र",
    "priority action": "प्राथमिकता कार्य",
    activities: "गतिविधिहरु",
    organization: "संस्‍था",
    "Note : Warning level for rainfall (mm): 60 mm in 1 hr, 80 mm in 3 hr, 100 mm in 6 hr, 120 mm in 12 hr, 140 mm in 24 hr. This indicates potential threat for landslides in steep slope and high flow in local areas.":
      "नोट: वर्षाको लागि चेतावनी स्तर (मिमी): १ घण्टामा ६० मिमी, ३ घण्टामा ८० मिमी, ६ घण्टामा १०० मिमी, १२ घण्टामा १२० मिमी, २४ घण्टामा १४० मिमी। यसले स्थानीय क्षेत्रमा ठाडो ढलान र उच्च प्रवाहमा पहिरोको सम्भावित खतरालाई सङ्केत गर्छ।",
    "Rainfall Watch": "वर्षाको डाटा",
    "Download csv": "csv डाउनलोड गर्नुहोस्",
    "No Publications to display": "प्रदर्शन गर्न कुनै प्रकाशनहरू छैनन्",
    "BIPAD: Building Information Platform Against Disaster":
      "विपद्: प्रकोप विरुद्ध जानकारी प्लेटफर्म निर्माण",
    "Disaster related data/information is one of the most crucial components for policy making, planning, and implementing DRRM activities.BIPAD is built at a time when disaster governance in Nepal is changing on account of federal restructuring of the country.However, disaster data/information is still scattered, insufficient and not fully harmonized.On this backdrop, BIPAD is developed by pooling all credible digital and spatial data that are available within different government bodies, non-governmental organizations, academic institutions and research organizations on a single platform.The platform has six modules in the portal that has the potential to:":
      "विपद् सम्बन्धी तथ्याङ्क/सूचना नीति निर्माण, योजना, र DRRM गतिविधिहरू कार्यान्वयन गर्नको लागि सबैभन्दा महत्त्वपूर्ण घटकहरू मध्ये एक हो। विपद् यस्तो समयमा निर्माण गरिएको हो जब देशको संघीय पुनर्संरचनाका कारण नेपालमा विपद् व्यवस्थापन परिवर्तन भइरहेको छ। यद्यपि, विपद् डेटा/ जानकारी अझै छरपस्ट, अपर्याप्त र पूर्णतया मेलमिलापमा छैन। यस पृष्ठभूमिमा, विभिन्न सरकारी निकायहरू, गैर-सरकारी संस्थाहरू, शैक्षिक संस्थाहरू र अनुसन्धान संस्थाहरू एकै प्लेटफर्ममा उपलब्ध सबै विश्वसनीय डिजिटल र स्थानिय डेटाहरू जम्मा गरेर विपद् विकसित गरिएको छ। प्लेटफर्मको पोर्टलमा छवटा मोड्युलहरू छन् जसमा सम्भाव्यता छ:",
    "Enhance preparedness and early warning":
      "तयारी र प्रारम्भिक चेतावनी बढाउनुहोस्",
    "Strengthen disaster communication": "प्रकोप संचार बलियो बनाउनुहोस्",
    "Strengthen emergency response": "आपतकालीन प्रतिकार्यलाई बलियो बनाउनुहोस्",
    "Enhance coordination post-incident": "घटना पछि समन्वय सुदृढ गर्नुहोस्",
    "Evidence-based planning, decision making and policy making":
      "प्रमाणमा आधारित योजना, निर्णय र नीति निर्माण",
    "The focus of the system is on bottom up approach of data collection,targeting the Provincial and Municipal governments to engage in verifying and collecting data.BIPAD is targeted for Emergency Operation Centers at National, Provincial and Municipal tiers of the government, and Nepal Police, who is the first responder to disaster. Other users of this system are the line ministries at National and Provincial tiers working in disaster management division and departments, Nepal Army, Armed Police Force, non-governmental organizations, research institutions and the general public.":
      "प्रणालीको फोकस तथ्याङ्क सङ्कलनको बटम अप अप्रोचमा रहेको छ, प्रादेशिक र नगरपालिका सरकारहरूलाई डेटा प्रमाणीकरण र सङ्कलनमा संलग्न गराउने लक्ष्यमा। विपद् सरकारका राष्ट्रिय, प्रादेशिक र नगरपालिका स्तरहरूमा आपतकालीन सञ्चालन केन्द्रहरू, र नेपाल प्रहरी, जो विपद्को पहिलो प्रतिकार्यकर्ता हो। यस प्रणालीका अन्य प्रयोगकर्ताहरू विपद् व्यवस्थापन महाशाखा र विभागहरूमा कार्यरत राष्ट्रिय र प्रादेशिक तहका लाइन मन्त्रालयहरू, नेपाली सेना, सशस्त्र प्रहरी बल, गैर-सरकारी संस्थाहरू, अनुसन्धान संस्थाहरू र आम जनता हुन्।",
    "The features in BIPAD inform the users about the details of an incident for both natural and non-natural hazards for response and for historical analysis of loss and damage. The system integrates electronic version of the incident reporting form used in collecting incident information by Nepal Police.":
      "विपद् मा रहेका सुविधाहरूले प्रयोगकर्ताहरूलाई प्रतिकार्यको लागि प्राकृतिक र गैर-प्राकृतिक खतराहरू र क्षति र क्षतिको ऐतिहासिक विश्लेषणको लागि घटनाको विवरणहरू बारे जानकारी दिन्छ। यस प्रणालीले नेपाल प्रहरीद्वारा घटनाको जानकारी सङ्कलन गर्न प्रयोग गरिने घटना रिपोर्टिङ फारमको इलेक्ट्रोनिक संस्करणलाई एकीकृत गर्दछ।",
    "The alert feature has the potential to pre-inform to take early actions to mitigate   disasters. BIPAD targets to provide crucial information on the capacity and resources, such as on health institutions, financial institutions, schools, banks, stockpiles, road network, inventories, NGOs, government agencies, etc. in relation to the incidents. The system incorporates hazard maps and vulnerability indicators that can be used for risk sensitive land use planning and DRR inclusive development activities. The system is built to accommodate repository of DRRM documents, status of DRRM projects, and relief budget tracking. It has provisions to monitor the government’s as well as non-government organizations’ projects on the basis of seven targets of Sendai Framework (2015-2030) and Priorities and Sub-Priorities of Disaster Risk Reduction Strategic Action plan 2018.":
      "अलर्ट फिचरमा विपद् न्यूनीकरण गर्न प्रारम्भिक कदम चाल्न पूर्व-सूचना दिने क्षमता छ। विपद्ले घटनाहरूका सम्बन्धमा स्वास्थ्य संस्था, वित्तीय संस्था, विद्यालय, बैंक, भण्डार, सडक सञ्जाल, सूची, गैरसरकारी संस्था, सरकारी निकायहरू आदि जस्ता क्षमता र स्रोतहरूमा महत्त्वपूर्ण जानकारी उपलब्ध गराउने लक्ष्य राखेको छ। प्रणालीले जोखिम नक्सा र जोखिम संकेतकहरू समावेश गर्दछ जुन जोखिम संवेदनशील भूमि प्रयोग योजना र DRR समावेशी विकास गतिविधिहरूको लागि प्रयोग गर्न सकिन्छ। प्रणाली DRRM कागजातहरूको भण्डार, DRRM परियोजनाहरूको स्थिति, र राहत बजेट ट्र्याकिङ समायोजन गर्न निर्माण गरिएको हो। यसमा सेन्डाई फ्रेमवर्क (२०१५-२०३०) र विपद् जोखिम न्यूनीकरण रणनीतिक कार्य योजना २०१८ को प्राथमिकता र उप-प्राथमिकताका सातवटा लक्ष्यका आधारमा सरकारी तथा गैरसरकारी संस्थाका आयोजनाहरूको अनुगमन गर्ने व्यवस्था छ।",
    "The above features of the system would be fully functional when credible data/information is integrated into the system coming from local level. The system is committed for the same.":
      "स्थानीय तहबाट आउने प्रणालीमा विश्वसनीय तथ्याङ्क/सूचनाहरू एकीकृत गर्दा प्रणालीका माथिका सुविधाहरू पूर्ण रूपमा कार्यात्मक हुनेछन्। त्यसका लागि प्रणाली प्रतिबद्ध छ ।",

    "Please provide the following details":
      "कृपया निम्न विवरणहरू प्रदान गर्नुहोस्",
    "Download a sample letter": "एउटा नमूना पत्र डाउनलोड गर्नुहोस्",
    "Welcome Back": "फिर्ता आउनु भएकोमा स्वागत छ",
    "To login to BIPAD Portal, please use your credentials.":
      "विपद् पोर्टलमा लगइन गर्न, कृपया आफ्नो प्रमाणहरू प्रयोग गर्नुहोस्।",
    "Sign in": "साइन इन गर्नुहोस्",
    "You are representing:": "तपाईं प्रतिनिधित्व गर्दै हुनुहुन्छ:",
    "Please select at least one field":
      "कृपया कम्तिमा एउटा क्षेत्र चयन गर्नुहोस्",
    Back: "पछाडि",
    Next: "अर्को",
    "I Agree": "म सहमत छु",
    "Thank you": "धन्यवाद",
    Close: "बन्द गर्नुहोस्",
    "For requesting the login credential.Following the submission, you will receive a confirmation email with a confirmation code.Our technical team will review your details and provide you a username and password.":
      "लगइन प्रमाणको अनुरोधको लागि।सबमिशन पछि, तपाईंले पुष्टिकरण कोडको साथ पुष्टिकरण इमेल प्राप्त गर्नुहुनेछ।हाम्रो प्राविधिक टोलीले तपाईंको विवरणहरू समीक्षा गर्नेछ र तपाईंलाई प्रयोगकर्ता नाम र पासवर्ड प्रदान गर्नेछ।",
    "The official email will be registered in the system and will be used as the primary email for any official correspondence.":
      "आधिकारिक इमेल प्रणालीमा दर्ता गरिनेछ र कुनै पनि आधिकारिक पत्राचारको लागि प्राथमिक इमेलको रूपमा प्रयोग गरिनेछ।",
    "Valid Official Email is required": "मान्य आधिकारिक इमेल आवश्यक छ",
    "Valid Phone no. is required": "मान्य फोन नम्बर आवश्यक",
    "Designation is required": "पदनाम आवश्यक छ",
    "Full Name is required": "पूरा नाम आवश्यक छ",
    "Full Name": "पुरा नाम",
    "Desingation (eg. IT Officer)": "पदनाम (जस्तै IT अधिकारी)",
    "+977": "+९७७",
    "Phone No.": "फोन नं.",
    "Official Email": "आधिकारिक इमेल",
    "Please attach the official letter": "कृपया आधिकारिक पत्र संलग्न गर्नुहोस्",
    "Please choose a valid letter file(.jpg, .jpeg, .pdf, .doc, .docx, .png)":
      "कृपया एउटा मान्य अक्षर फाइल (.jpg, .jpeg, .pdf, .doc, .docx, .png) छान्नुहोस्।",
    "BIPAD portal is a Government owned integrated and comprehensive Disaster Information Management System.It aims to bring together all credible digital and spatial data into a single platform to strengthen the preparedness, mitigation, and response activities of all related stakeholders working in this sector.This one stop platform has been developed with the concept of creating a national portal embedded with independent platforms for national, provincial, and municipal government with a bottom-up approach of disaster data partnership.":
      "विपद् पोर्टल सरकारी स्वामित्वको एकीकृत र व्यापक विपद् सूचना व्यवस्थापन प्रणाली हो। यसले यस क्षेत्रमा काम गर्ने सबै सम्बन्धित सरोकारवालाहरूको तयारी, न्यूनीकरण र प्रतिकार्य गतिविधिहरूलाई सुदृढ गर्न सबै विश्वसनीय डिजिटल र स्थानिय डेटालाई एकै प्लेटफर्ममा ल्याउने लक्ष्य राख्छ। स्टप प्लेटफर्म राष्ट्रिय, प्रादेशिक र नगरपालिका सरकारहरूका लागि स्वतन्त्र प्लेटफर्महरू इम्बेड गरिएको राष्ट्रिय पोर्टल सिर्जना गर्ने अवधारणाको साथ विकसित गरिएको छ जसमा प्रकोप डाटा साझेदारीको बटम-अप दृष्टिकोण रहेको छ।",
    "Authorized government body from each province, district, and municipality will receive a single login credential.You can request for the username and password once.":
      "प्रत्येक प्रदेश, जिल्ला र नगरपालिकाबाट आधिकारिक सरकारी निकायले एकल लगइन प्रमाण प्राप्त गर्नेछ। तपाइँ एक पटक प्रयोगकर्ता नाम र पासवर्डको लागि अनुरोध गर्न सक्नुहुन्छ।",
    "I hereby confirm that I am a government employee requesting for the login credential for the first time":
      "म यसद्वारा पुष्टि गर्दछु कि म पहिलो पटक लगइन प्रमाणका लागि अनुरोध गर्ने सरकारी कर्मचारी हुँ",
    "Please agree to the terms and conditions before continuing":
      "जारी राख्नु अघि कृपया नियम र सर्तहरूमा सहमत हुनुहोस्",

    "Welcome to BIPAD Portal": "विपद् पोर्टलमा स्वागत छ",
    "An integrated and comprehensive DIMS platform to support disaster risk management through informed decision making.":
      "सूचित निर्णय लिने माध्यमबाट प्रकोप जोखिम व्यवस्थापनलाई समर्थन गर्न एक एकीकृत र व्यापक DIMS प्लेटफर्म।",
    Username: "प्रयोगकर्ता नाम",
    Password: "पासवर्ड",
    "Forgot Password": "पासवर्ड भुल्नु भयो",
    Login: "लग ईन",
    "Other logins:": "अन्य लगइनहरू:",
    MDSA: "",
    "Do not have an account?": "खाता छैन?",
    "Click to request BIPAD login credential":
      "विपद् लगईन प्रमाणहरू अनुरोध गर्न क्लिक गर्नुहोस्",
    "PASSWORD REQUEST": "पासवर्ड अनुरोध",
    "Disaster count": "विपद् गणना",
    Relocated: "स्थानान्तरण गरिएको",
    Evacuated: "खाली गरिएको",
    Dimension: "आयाम",
    "Livestock Loss": "पशुचौपायाको क्षति",
    Destroyed: "नष्ट भएको",
    "Infrastructure Loss": "पूर्वाधारको क्षेति",
    House: "घर",
    Bridges: "पुलहरू",
    Bridge: "पुल",
    Road: "सडक",
    Electricity: "बिजुली",
    "Please select a situation report": "कृपया स्थिति रिपोर्ट चयन गर्नुहोस्",
    "There are no incidents in this situation report":
      "यस स्थिति रिपोर्टमा कुनै घटनाहरू छैनन्",
    "Disaster Summary": "प्रकोप संक्षेप",
    "Family Loss": "पारिवारिक क्षेति",
    "People Loss": "मानव हानि",
    "Casuality Statistics": "दुर्घटना तथ्याङ्क",
    Download: "डाउनलोड गर्नुहोस्",
    "Incident Situation Report": "घटना स्थिति रिपोर्ट",
    "Incident Statistics": "घटना तथ्याङ्क",
    "BIPAD Portal": "विपद् पोर्टल",
    "Bipad Portal": "विपद् पोर्टल",
    "Loading data": "डाटा लोड गर्दै",
    "Loading Page": "पेज लोड गर्दै",
    "Loading Resources": "स्रोतहरू लोड गर्दै",
    Region: "क्षेत्र",
    Latitude: "अक्षांश",
    Longitude: "देशान्तर",
    Description: "विवरण",
    "Street Address": "सडक ठेगाना",
    "Upload Image": "फोटो अपलोड गर्नुहोस्",
    Image: "फोटो",
    "Incident on": "घटना घटेको मिति",
    "Some problem occurred.": "केही समस्या आयो।",
    Reload: "पुन: लोड गर्नुहोस्",
    "Risk Info / Hazard": "जोखिम जानकारी / प्रकोप",
    "Risk Info / Exposure": "जोखिम जानकारी / सम्मुखता",
    "Risk Info / Vulnerability": "जोखिम जानकारी / संकटासन्‍नता",
    "Risk Info / Risk": "जोखिम जानकारी / जोखिम",
    "Risk Info / Capacity and Resources": "जोखिम जानकारी / श्रोत तथा क्षमता",
    "Risk Info / Climate change": "जोखिम जानकारी / जलवायु परिवर्तन",
    Population: "जनसंख्या",
    Literacy: "साक्षरता",
    Household: "घरायसी",
    "Age Group": "उमेर समूह",
    "Demographics of Nepal": "नेपालको जनसांख्यिकी",
    Injured: "घाइते",
    Injury: "चोट",
    Affected: "प्रभावित",
    Missing: "हराइरहेको",
    "Infrastructures destroyed": "पूर्वाधारको क्षति",
    "Loss by year": "वर्ष अनुसार घाटा",
    Summary: "सारांश",
    Projects: "परियोजना",
    Contacts: "सम्पर्क",
    Document: "कागजात",
    Indicators: "सूचकहरू",
    "Available resources": "उपलब्ध स्रोतहरू",
    Education: "शिक्षा",
    Health: "स्वास्थ्य",
    Finance: "वित्त",
    Communication: "सञ्चार",
    Governance: "सुशासन",
    Tourism: "पर्यटन",
    Industries: "उद्योगहरू",
    "Religious sites": "धार्मिक स्थलहरू",
    "Energy station": "ऊर्जा स्टेशन",
    Realtime: "वास्तविक समय",
    Profile: "प्रोफाइल",
    "Risk Info": "जोखिम जानकारी",
    National: "राष्‍ट्रिय",
    Logout: "लग आउट",
    "About Us": "हाम्रो बारे",
    "Reported incidents": "घटना रिपोर्ट",
    "Report an incident": "घटना रिपोर्ट गर्नुहोस्",
    Relief: "राहत",
    "Situation Report": "स्थिति रिपोर्ट",
    "Data Archive": "डाटा संग्रह",
    "DRRM Report": "डिआरआरएम रिपोर्ट",
    "Rain watch": "वर्षा डाटा",
    "River watch": "नदी डाटा",
    "River Watch": "नदी डाटा",
    "Data source": "डाटाको स्रोत",
    DateRangeInfo: "डाटाको अवधि",
    to: "सम्म",
    "Realtime Module": "रिअलटाईम मोडुल",
    Alerts: "सतर्कता",
    Events: "घटना संख्या",
    Visualizations: "Visualizations",
    "New alert": "नयाँ चेतावनी थप्न",
    "New event": "नया घटना थप्न",
    "Flood at": "बाढी",
    Ma: "मा",
    Edit: "सम्पादन गर्नुहोस्",
    Delete: "मेटाउनुहोस्",
    Filters: "फिल्टर",
    Submit: "पेस गर्नुहोस्",
    Dashboard: "ड्यासबोर्ड",
    Incident: "घटना",
    "Damage & Loss": "क्षति र हानि",
    "There are no major events at the moment.":
      "चयन गरिएको समय अवधिमा कुनै घटना छैन",
    "Number of Alerts": "सतर्कता को संख्या",
    "No Alerts in the Selected Time Period":
      "चयन गरिएको समय अवधिमा कुनै अलर्ट छैन ",
    "Hazard Occurence Statistics": "प्रकोप घटना तथ्या्क",
    hazardSummary: [
      {
        label: "भूकम्प",
      },
      {
        label: "वातावरणीय प्रदूषण",
      },
      {
        label: "बाढी",
      },
      {
        label: "भारी वर्षा",
      },
    ],
    New: "नयाँ",
    "Data sources": "डाटा स्रोत",
    "DRR Portal": "विपद् जोखिम न्यूनीकरण पोर्टल",
    Incidents: "घटना संख्या",
    "People death count": "मृत्यु संख्या",
    "Hazards Legend": "प्रकोप अनुसूची",
    "New incident": "नया घटना थप्न",
    Feedbacks: "प्रतिकार्यहरु ",
    "Feedback and support": "प्रतिक्रिया र समर्थन",
    Source: "स्रोत",
    Status: "स्थिति",
    Verified: "प्रमाणित",
    "Not verified": "प्रमाणित छैन",
    "Go to response": "प्रतिकार्यमा जानुहोस्",
    "High Altitude": "उच्च ऊंचाई",
    Landslide: "पहिरो",
    Flood: "बाढी",
    "Boat Capsize": "डुंगा पल्टिनु",
    Thunderbolt: "चट्याङ्ग",
    "Snake Bite": "सर्पदंश",
    Fire: "आगलागी",
    Drowning: "डुबेर मर्नु",
    "Others (Non-Natural)": "अन्य गैरप्राकृतिक विपद्",
    "Heavy Rainfall": "भारीवर्षा",
    "Wind Storm": "हुरी बतास",
    "Cold Wave": "शीतलहर",
    Earthquake: "भूकम्प",
    "Helicopter Crash": "हेलिकप्टर दुर्घटना",
    "Leakage (toxic gas)": "विषाक्त ग्याँस चुहावट",
    "Response Accident": "प्रकोप उद्धार कार्यमा हुने दुर्घटना",
    Hailstorm: "असिना",
    "Forest Fire": "वन डढेँलो",
    "Leakage (radiation)": "विकिरण चुहावट",
    Epidemic: "महामारी",
    "Leakage (chemical)": "रसायन चुहावट",
    "Volcanic eruption": "ज्वालामुखी बिस्फोट",
    "Bridge Collapse": "पुल भत्कीनु",
    Avalanche: "हिमपहिरो",
    "Animal Incidents": "जनावर आतङ्क",
    "Aircraft Accident": "हवाई दुर्घटना",
    Inundation: "डुबान",
    "Animal flu": "पशु वा चराचुरुङ्गीमा हुने फ्लू",
    "Water Accident": "जल दुर्घटना",
    "Gas explosion": "ग्याँस विष्फोटन",
    "Food poisoning": "विषाक्त खाद्य सेवन",
    Famine: "अनिकाल",
    "Soil Erosion": "भू-स्खलन",
    "Other (Natural)": "अन्य प्राकृतिक विपद्",
    "Glacial lake outburst": "हिमताल विस्फोटन",
    "Microorganism attack": "किट वा सूक्ष्म जिवाणु आतङ्क",
    "Environmental pollution": "वातावरणीय प्रदूषण",
    Pollution: "प्रदूषण",
    "Heat wave": "तातो हावाको लहर",
    Storm: "आँधी",
    "Mine disaster": "खानी दुर्घटना",
    "Road accident": "सडक दुर्घटना",
    "Industrial disaster": "औद्योगिक दुर्घटना",
    Drought: "खडेरी",
    Pandemics: "प्यान्डामिक फ्लू",
    "Snow Storm": "हिमपात",
    Deforestation: "वन विनाश",
    Rainfall: "अनावृष्टि",
    Province: "प्रदेश",
    District: "जिल्‍ला",
    Municipality: "नगरपालिका",
    Ward: "वार्ड",
    "All districts": "सबै जिल्ला",
    "All municipalities": "सबै नगरपालिकाहरु",
    "All provinces": "सबै प्रदेशहरु",
    "All wards": "सबै वार्डहरु",
    Location: "स्थान",
    "Reset filters": "फिल्टर रिसेट गर्नुहोस्",
    Hazard: "प्रकोप",
    "Data range": "डाटाको समय",
    Others: "अरु",
    Natural: "प्राकृतिक",
    "Non-natural": "गैर प्राकृतिक",
    "Start Date": "सुरू मिति",
    "End Date": "अन्त्य मिति",
    "Earthquake at": "भूकम्प केन्द्र बिन्दु",
    "N/A": "लागु हुँदैन",
    Magnitude: "परिमाण",
    "Department of Mines and Geology": "खानी तथा भूगर्भ विभाग",
    ML: "एम एल",
    "International Centre for Integrated Mountain Development":
      "एकीकृत पर्वत विकास को लागी अन्तर्राष्ट्रिय केन्द्र",
    Brightness: "चमक",
    "Land Cover": "भूउपयोग",
    "Very Unhealthy": "धेरै अस्वस्थ",
    Good: "राम्रो",
    Moderate: "मध्यम",
    "Unhealthy for Sensitive People": "संवेदनशील मानिसहरुको लागी अस्वस्थ",
    Unhealthy: "अस्वस्थ",
    Hazardous: "खतरनाक",
    "Ministry of Forests and Environment": "वन तथा वातावरण मन्त्रालय",
    Remark: "टिप्पणी",
    AQI: "वायु गुणस्तर सूचकांक",
    Basin: "बेसिन",
    "Accumulated Rainfall": "संचित वर्षा",
    Hour: "घण्टा",
    "Department of Hydrology and Meteorology": "जल तथा मौसम विज्ञान विभाग",
    "Station Name": "स्टेशनको नाम",
    "WATER LEVEL": "पानी तह",
    "People death": "मृत्यु संख्या",
    "Estimated loss (NPR)": "अनुमानित आर्थिक क्षति (रु )",
    "Infrastructure destroyed": "पूर्वाधारको क्षति",
    "Livestock destroyed": "पशुचौपाया क्षति",
    "LEAVE FEEDBACK": "सुझाव दिनुहोस्",
    "Number of Incidents": "घटनाको संख्या",
    "Hazard Severity (Fatality due to Hazard)":
      "प्रकोप गम्भीरता (प्रकोपको कारण मृत्यु)",
    DateMismatchWarning: "चेतावनी! सुरु मिति अन्त्य मिति भन्दा ठूलो हुन सक्दैन",
    "Compare Regions": "क्षेत्रहरू तुलना गर्नुहोस्",
    "Show data in tabular format": "तालिका ढाँचामा डेटा देखाउनुहोस्",
    "No. of incidents": "घटनाको संख्या",
    "Estimated loss": "अनुमानित क्षति",
    in: "",
    "First location": "पहिलो स्थान",
    "Second location": "दोस्रो स्थान",
    "Select an option": "विकल्प चयन गर्नुहोस्",
    SelectMessage: "कृपया तुलना सुरु गर्न स्थानहरू चयन गर्नुहोस्",
    "Estimated Monetary Loss": "अनुमानित आर्थिक क्षेति (रु )",
    "Death toll by disaster": "प्रकोपबाट मृत्यु हुनेको संख्या",
    "Estimated economic loss by disaster": "विपद् बाट अनुमानित आर्थिक क्षेति",
    "Realtime layers": "वास्तविक समय तहहरू",
    "Others layers": "अन्य तहहरू",
    Rain: "वर्षा",
    River: "नदी",
    "Earthquake (ML)": "भूकम्प ML)",
    "Pollution (AQI Value)": "प्रदूषण (AQI)",
    StreamFlow: "स्ट्रिमफ्लो",
    "Other layers": "अन्य तहहरू",
    ndrrma: "राष्ट्रिय विपद् जोखिम न्यूनीकरण तथा व्यवस्थापन प्राधिकरण",
  },
};
